<template>
	<div
	  class="bg-white px-3"
	  style="margin: -20px; margin-top: -1rem; margin-bottom: 0 !important"
	>

		<div v-if="createModel == 2">
			<div class="mb-2 mt-2 pt-3">
				<template >
					<el-header style="display: inline-block;">比賽</el-header>
				</template>
				<div style="float: right;">
					<el-button @click="resetForm">返 回</el-button>
				</div>
			</div>
			<el-form :rules="ruless" ref="form" :model="form" :label-width="layout.is_phone?'80px':'130px'">
				<el-form-item  label="比賽圖標" prop="icon" >
					<el-upload
					name="file"
					  class="avatar-uploader"
					  action="/admin/image/uploadNew"
					  :headers="{token:$store.state.user.token}"
					  :data="{type:'8',cms_type:'2'}"
					  :show-file-list="false"
					  :on-success="handleAvatarSuccessLogo"
					  :before-upload="beforeAvatarUpload">
					  <img v-if="form.logo" :src="form.logo" class="avatar">
					  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
					</el-upload>
					<span style="color: red;">圖片比例為 1*1 的正方形</span>
				</el-form-item>

				<el-form-item label="比賽名稱" prop="title">
					<el-input size="small" v-model="form.title" placeholder="比賽名稱" style="width: 85%;"></el-input>
				</el-form-item>
				<el-form-item label="比賽副標題1" prop="title_vice">
					<el-input v-model="form.title_vice" placeholder="比賽副標題1" clearable size="small" maxlength="25" show-word-limit   style="width: 85%;"></el-input>
				</el-form-item>
			<el-form-item label="比賽副標題2" prop="title_vices">
				<el-input v-model="form.title_vices" placeholder="比賽副標題2" clearable size="small" maxlength="25" show-word-limit   style="width: 85%;"></el-input>
			</el-form-item>

			<el-form-item label="比賽副標題2圖片1" prop="title_vice_img1">
				<el-upload
					name="file"
					class="avatar-uploader"
					action="/admin/image/uploadNew"
					:headers="{token:$store.state.user.token}"
					:data="{type:'8',cms_type:'2'}"
					:show-file-list="false"
					:on-success="handleAvatarSuccessTitleViceImg1"
					:before-upload="beforeAvatarUpload">
					<img v-if="form.title_vice_img1_logo" :src="form.title_vice_img1_logo" class="avatar">
					<i v-else class="el-icon-plus avatar-uploader-icon"></i>
				</el-upload>
				<span style="color: red;">圖片比例為 1*1 的正方形</span>
			</el-form-item>

			<el-form-item label="比賽副標題2圖片2" prop="title_vice_img2">
				<el-upload
					name="file"
					class="avatar-uploader"
					action="/admin/image/uploadNew"
					:headers="{token:$store.state.user.token}"
					:data="{type:'8',cms_type:'2'}"
					:show-file-list="false"
					:on-success="handleAvatarSuccessTitleViceImg2"
					:before-upload="beforeAvatarUpload">
					<img v-if="form.title_vice_img2_logo" :src="form.title_vice_img2_logo" class="avatar">
					<i v-else class="el-icon-plus avatar-uploader-icon"></i>
				</el-upload>
				<span style="color: red;">圖片比例為 1*1 的正方形</span>
			</el-form-item>

			<el-form-item  label="比賽簡介" prop="content">
					<quill-editor ref="text" v-model="form.content" style="width: 85%;height: 300px;padding-bottom: 60px;" />
				</el-form-item>

				<el-form-item  label="獎項備註" prop="prize_info">
								<el-input type="textarea" :rows="2" v-model="form.prize_info" 
								placeholder="獎項備註" 
								maxlength="50"
								show-word-limit  
								clearable size="small" style="width: 85%;"></el-input>
							</el-form-item>


				<el-form-item label="學科類型"   prop="subject_id">
								<el-select @change="changeType" v-model="form.subject_id">
									<el-option
									v-for="item in subject_list"
									:key="item.id"
									:label="item.name"
									:value="item.id">
									</el-option>
								</el-select>
							</el-form-item>
									<el-form-item  label="是否免費"  prop="pay_type">
										<el-radio-group v-model="form.pay_type" >
											<el-radio :label="1">免費</el-radio>
											<el-radio :label="2">付費</el-radio>
										</el-radio-group>
									</el-form-item>

									<el-form-item label="付費金額" prop="money"	v-show="form.pay_type==2">
										<el-input v-model="form.money" placeholder="付費金額" clearable size="small" style="width: 65%;"></el-input>
										<span class="text-info" style="margin-left: 20px;">學校用戶</span>
									</el-form-item>

									<el-form-item label="付費金額" prop="no_school_money"	v-show="form.pay_type==2">
										<el-input v-model="form.no_school_money" placeholder="付費金額" clearable size="small" style="width: 65%;"></el-input>
										<span class="text-success" style="margin-left: 20px;">非學校用戶</span>
									</el-form-item>

									<el-form-item label="參加用戶類型">
										<el-radio-group v-model="form.is_school">
											<el-radio :label="0">全部</el-radio>
											
											<!-- 自定義框 -->
											<div class="custom-box">
											<el-radio :label="1">非學校用戶</el-radio>
											<el-radio :label="2">全部學校</el-radio>
											<el-radio :label="3">指定學校</el-radio>
											<el-radio :label="4">用戶標籤</el-radio>
											</div>
										</el-radio-group>
									</el-form-item>
									
									<el-form-item label="參加學校" prop="school_id" v-show="form.is_school == 3">
										<el-select v-model="form.school_id" multiple filterable  style="width: 85%;" placeholder="請選擇">
											<el-option
											v-for="item in school_list"
											:key="item.id"
											:label="item.school_no +' - '+ item.add_name + ' - ' + item.name"
											:value="item.id">
											</el-option>
										</el-select>
									</el-form-item>

									<el-form-item label="用戶標籤" prop="user_label_ids" v-show="form.is_school == 4">
										<el-select v-model="form.user_label_ids" multiple filterable clearable style="width: 85%;" placeholder="請選擇">
											<el-option
											v-for="item in user_label_options"
											:key="item.id"
											:label="item.name"
											:value="item.id">
											</el-option>
										</el-select>
									</el-form-item>

									<el-form-item label="報名日期" prop="time" size="small"  >
										<el-date-picker
											v-model="form.time"
											type="daterange"
											align="right"
											unlink-panels
											value-format="yyyy-MM-dd"
											range-separator="至"
											start-placeholder="開始日期"
											end-placeholder="結束日期"
											@change="updateDateLimits"
											:picker-options="pickerOptions">
									</el-date-picker>
							</el-form-item>
									
							<el-form-item label="成績公布日期" prop="result_date"  size="small"  >
										<el-date-picker
										v-model="form.result_date"
										value-format="yyyy-MM-dd HH:mm:ss"
										type="datetime"
										placeholder="選擇日期"
										:picker-options="dateLimits">
										</el-date-picker>
							</el-form-item>
							
							<el-form-item label="訂購獎品截止" prop="end_time"  size="small"  >
										<el-date-picker
										v-model="form.end_time"
										value-format="yyyy-MM-dd"
										type="date"
										placeholder="選擇日期"
										:picker-options="dateLimits">
										</el-date-picker>
							</el-form-item>

							<el-form-item label="公告截止展示" prop="notice_end_time" size="small"  >
								<el-date-picker
									v-model="form.notice_end_time"
									value-format="yyyy-MM-dd"
									type="date"
									placeholder="選擇日期"
									:picker-options="dateLimits">
								</el-date-picker>
							</el-form-item>

							<el-form-item label="截止查看成績" prop="check_rank_time" size="small"  >
								<el-date-picker
									v-model="form.check_rank_time"
									value-format="yyyy-MM-dd"
									type="date"
									placeholder="選擇日期"
									:picker-options="dateLimits">
								</el-date-picker>
							</el-form-item>
							
							<el-form-item label="顯示倒計時" prop="is_show_time">
								<el-switch
									v-model="form.is_show_time"
									:active-value="1"
									:inactive-value="0"
									active-text="顯示"
									inactive-text="隱藏">
								</el-switch>
							</el-form-item>
							
							<el-form-item label="優惠碼" prop="discount_code"  size="small"  >
								<el-input v-model="form.discount_code" placeholder="優惠碼" clearable size="small" style="width: 65%;"></el-input>
							</el-form-item>

							<el-form-item label="優惠金額" prop="discount_money"  size="small"  >
								<el-input v-model="form.discount_money" placeholder="優惠金額" type="number" clearable size="small" style="width: 65%;"></el-input>
							</el-form-item>
						
						
							<el-form-item label="試卷" prop="paperList">
								<el-table :data="form.paperList" border style="width: 100%" @selection-change="handleSelectionChange">
									<el-table-column type="expand" label="題目" align="center" width="60">
									<!-- 使用作用域插槽访问當前行數据 -->
									<template slot-scope="scope">
										<!-- 绑定内嵌表格數据到當前行的topList属性 -->
										<el-table :data="scope.row.topList" border style="width: 100%" @selection-change="handleSelectionChange">
											<el-table-column align="center" prop="title" label="題目"></el-table-column>
											<el-table-column align="center" prop="score" label="分數"></el-table-column>
											

												<el-table-column align="center"  prop="label_name" label="標籤">
													<template slot-scope="scope">
														<span>
															<el-tag >{{scope.row.label_name}}</el-tag>
														</span>
													</template>
												</el-table-column>
												
												<el-table-column align="center" width="200"  prop="topic_type"  label="類型">
													<template slot-scope="scope">
														<el-tag v-if="scope.row.topic_type==1" type="success">選擇題</el-tag>
														<el-tag v-if="scope.row.topic_type==2" >填空題</el-tag>
														<el-tag v-if="scope.row.topic_type==3">上傳題</el-tag>
													</template>
												</el-table-column>
										</el-table>
									</template>
									</el-table-column>
									<el-table-column align="center" prop="name" label="年級組名稱"></el-table-column>
									<el-table-column align="center" prop="count" label="題目數"></el-table-column>
									<el-table-column align="center" prop="total_score" label="總分"></el-table-column>
									<el-table-column prop="id" align="center" width="140" label="操作">
										<template slot-scope="scope">
											<el-button-group>
												<el-button size="mini" plain type="primary" @click="addDomain(scope)">操作</el-button>
												<el-button @click="delDomain(scope)" v-auth="'delAdmin'" size="mini" plain type="danger">刪除</el-button>
											</el-button-group>
										</template>
									</el-table-column>
								</el-table>
							</el-form-item>
							
							<el-form-item label="名次-獎品" prop="ranking">
								<el-button @click="addRankingUpdate(false)" style="margin-bottom: 10px;">添加名次-獎品</el-button>
								<el-table :data="form.ranking" border style="width: 100%" @selection-change="handleSelectionChange">
									<el-table-column type="expand" label="獎品" align="center" width="60">
										<template slot-scope="scope">
											<el-table :data="scope.row.prize" border style="width: 100%" @selection-change="handleSelectionChange">
												<el-table-column align="center" prop="name" label="獎品名稱"></el-table-column>
												<el-table-column align="center" prop="money" label="金額"></el-table-column>
												<el-table-column align="center" prop="content" label="獎品備註"></el-table-column>	
											</el-table>
										</template>
									</el-table-column>
									<el-table-column align="center" prop="level_name" label="名次"></el-table-column>
									<el-table-column align="center" prop="level" label="戰績">
										<template slot-scope="v">
											<el-tag v-if="v.row.level==1" >金</el-tag>
											<el-tag v-if="v.row.level==2" >銀</el-tag>
											<el-tag v-if="v.row.level==3" >銅</el-tag>
											<el-tag v-if="v.row.level==4" >其他</el-tag>
										</template>
									</el-table-column>
									<el-table-column align="center" prop="rank_show" label="榜單排名">
										<template slot-scope="v">
											<el-tag v-if="v.row.rank_show==1" >金</el-tag>
											<el-tag v-if="v.row.rank_show==2" >銀</el-tag>
											<el-tag v-if="v.row.rank_show==3" >銅</el-tag>
											<el-tag v-if="v.row.rank_show==0" >其他</el-tag>
										</template>
									</el-table-column>
									<el-table-column align="center" prop="diamond" label="贈送鑽石"></el-table-column>
									<el-table-column align="center" prop="money" label="贈送金幣"></el-table-column>
									<el-table-column prop="id" align="center" width="140" label="操作">
										<template slot-scope="scope">
											<el-button-group>
												<el-button size="mini" plain type="primary" @click="addRankingUpdate(scope)">操作</el-button>
												<el-button @click="addRankingUpdate(scope)" :disabled="scope.row.is_default ? true : false" v-auth="'delAdmin'" size="mini" plain type="danger">刪除</el-button>
											</el-button-group>
										</template>
									</el-table-column>
								</el-table>
							</el-form-item>

							<el-form-item  label="獎品購買備註" prop="message">
								<el-input type="textarea" :rows="3" v-model="form.message" 
								placeholder="獎品購買備註" 
								maxlength="1000"
								show-word-limit  
								clearable size="small" style="width: 85%;"></el-input>
							</el-form-item>

					</el-form>
					<div slot="footer"  style="text-align: center;    padding: 10px 0 30px 0;">
						<el-button @click="resetForm">取 消</el-button>
						<el-button :loading="submitLoading" type="primary" @click="submit" v-if="update_com == 1">確 定</el-button>
					</div>
					<el-dialog :close-on-click-modal="false"  title="題目" :visible.sync="createTagModel" 
			top="5vh" :width="layout.is_phone?'90%':'50%'" >
			<div ref="dialogContent" style="max-height: 65vh; overflow: auto;">
				<!-- 表單内容 -->
				<el-form ref="topForm"  :model="topForm" :label-width="layout.is_phone?'80px':'100px'" :label-position="layout.is_phone?'top':'left'">
					<el-form-item  label="題目圖片" prop="icon" >
						<el-upload
						name="file"
						class="avatar-uploader"
						action="/admin/image/uploadNew"
						:headers="{token:$store.state.user.token}"
						:data="{type:'1',cms_type:'2'}"
						:show-file-list="false"
						:on-success="handleAvatarSuccess"
						:before-upload="beforeAvatarUpload"
						>
						<img v-if="topForm.icon" :src="topForm.icon" class="avatar">
						<i v-else class="el-icon-plus avatar-uploader-icon"></i>
						</el-upload>
					</el-form-item>

					<el-form-item label="題目標籤"  prop="label_id">
						<el-select v-model="topForm.label_id" >
							<el-option
								v-for="item in label_list"
								:key="item.id"
								:label="item.name"
								:value="item.id">
							</el-option>
							<!-- <el-option v-if="label_list.length === 0" disabled value="">暂无可选標籤</el-option> -->
						</el-select>
					</el-form-item>

					<el-form-item  label="題目類型"   prop="topic_type">
						<el-radio-group v-model="topForm.topic_type" >
							<el-radio :label="1">選擇題</el-radio>
							<el-radio :label="2">填空題</el-radio>
							<el-radio :label="3">上傳題</el-radio>
						</el-radio-group>
					</el-form-item>

					<el-form-item label="分數" prop="score">
						<el-input type="number" v-model="topForm.score" 
						placeholder="題目分數" 
						clearable size="small" style="width: 85%;">
						</el-input>
					</el-form-item>
					
					<el-form-item label="題目" prop="title">
						<el-input type="textarea" :rows="8" v-model="topForm.title" 
						placeholder="題目" 
						clearable size="small" style="width: 85%;"></el-input>
					</el-form-item>


					<el-form-item label="難度" prop="difficulty">
						<el-rate
							style="line-height: 49px;"
							v-model="topForm.difficulty"
							:colors="colors">
						</el-rate>
					</el-form-item>
		
					<div v-if="topForm.topic_type == 1">
						<el-form-item label="A" prop="option_a">
							<el-input type="text" v-model="topForm.option_a" clearable size="small" style="width: 75%;margin-right: 10px;"></el-input>
							<el-radio v-model="topForm.answer_o" label="a">正確答案</el-radio>
						</el-form-item>

						<el-form-item label="B" prop="option_b">
							<el-input type="text" v-model="topForm.option_b" clearable size="small" style="width: 75%;margin-right: 10px;"></el-input>
							<el-radio v-model="topForm.answer_o" label="b">正確答案</el-radio>
						</el-form-item>

						<el-form-item label="C" prop="option_c">
							<el-input type="text" v-model="topForm.option_c" clearable size="small" style="width: 75%;margin-right: 10px;"></el-input>
							<el-radio v-model="topForm.answer_o" label="c">正確答案</el-radio>
						</el-form-item>

						<el-form-item label="D" prop="option_d">
							<el-input type="text" v-model="topForm.option_d" clearable size="small" style="width: 75%;margin-right: 10px;"></el-input>
							<el-radio v-model="topForm.answer_o" label="d">正確答案</el-radio>
						</el-form-item>
					</div>
					<div v-else-if="topForm.topic_type == 2">
						<el-form-item>
							<el-button type="primary" @click="addAnswer">新增答案</el-button>
						</el-form-item>
						<el-form-item label="答案" prop="answer">
							<div v-for="(answer, index) in topForm.answer" :key="index" style="display: flex; align-items: center;">
								<el-input
									type="text"
									v-model="topForm.answer[index]"
									placeholder="輸入答案"
									clearable
									size="small"
									style="width: 85%; margin-right: 10px;"
								></el-input>
								<el-button
									type="danger"
									icon="el-icon-delete"
									size="small"
									:disabled="topForm.answer.length === 1"
									@click="removeAnswer(index)"
								>删除</el-button>
							</div>
						</el-form-item>
					</div>
					
				</el-form>
			</div>
				<div slot="footer" class="dialog-footer">
					<el-button @click="resetTagForm">取 消</el-button>
					<el-button type="primary" @click="submitTag">確 定</el-button>
				</div>
			</el-dialog>
			<el-dialog :close-on-click-modal="false"  :before-close="handleClose" title="獎品" :visible.sync="createRankingModel" top="5vh" :width="layout.is_phone?'90%':'80%'">
				<div style="max-height: 65vh; overflow: auto;">
				<!-- 表單内容 -->
				<el-form  ref="formRanking" :model="formRanking" :label-width="layout.is_phone?'80px':'100px'">
					<el-form-item   label="名次" prop="level_name">
						<el-input v-model="formRanking.level_name" maxlength="20" :disabled="formRanking.is_default ? true : false" show-word-limit placeholder="名次" clearable size="small" style="width: 85%;"></el-input>
					</el-form-item>
					
					<el-form-item label="鑽石" prop="diamond">
						<el-input type="number" v-model="formRanking.diamond" 
						placeholder="鑽石數量" 
						clearable size="small" style="width: 85%;">
						</el-input>
					</el-form-item>
					
					<el-form-item label="金幣" prop="money">
						<el-input type="number" v-model="formRanking.money" 
						placeholder="金幣數量" 
						clearable size="small" style="width: 85%;">
						</el-input>
					</el-form-item>

					<el-form-item label="贈送禮物" prop="gift_id"	>
										<el-select  v-model="formRanking.gift_id" style="width: 85%;" multiple filterable placeholder="請選擇">
											<el-option
											v-for="item in user_gift"
											:key="item.id"
											:label="item.type_name"
											:disabled="item.disabled"
											:value="item.id">
											</el-option>
										</el-select>
									</el-form-item>

									<el-form-item  label="戰績" >
										<el-radio-group v-model="formRanking.level" >
											<el-radio :label="1">金</el-radio>
											<el-radio :label="2">銀</el-radio>
											<el-radio :label="3">銅</el-radio>
											<el-radio :label="4">其他</el-radio>
										</el-radio-group>
									</el-form-item>

									<el-form-item  label="榜單排名" >
										<el-radio-group v-model="formRanking.rank_show" >
											<el-radio :label="1">金</el-radio>
											<el-radio :label="2">銀</el-radio>
											<el-radio :label="3">銅</el-radio>
											<el-radio :label="0">其他</el-radio>
										</el-radio-group>
									</el-form-item>
									<el-form-item >
						<el-button @click="addPrize(false)">添加獎品</el-button>
					</el-form-item>
					<el-form-item label="獎品" prop="topList">
						<el-table :data="formRanking.prize" border style="width: 100%" @selection-change="handleSelectionChange">
							<el-table-column align="center" prop="name" label="獎品名稱"></el-table-column>
							<el-table-column align="center" prop="money" label="金額"></el-table-column>
							<el-table-column align="center" prop="postage" label="郵費"></el-table-column>
							<el-table-column align="center" prop="content" label="獎品備註"></el-table-column>
						
							<el-table-column prop="id" align="center" width="140" label="操作">
								<template slot-scope="scope">
									<el-button-group>
										<el-button size="mini" plain type="primary" @click="addPrize(scope)">操作</el-button>
										<el-button @click="delPrize(scope)" v-auth="'delAdmin'" size="mini" plain type="danger">刪除</el-button>
									</el-button-group>
								</template>
							</el-table-column>
						</el-table>
					</el-form-item>
				</el-form>
			</div>
				<div slot="footer" class="dialog-footer">
					<el-button @click="resetRankingForm">取 消</el-button>
					<el-button type="primary" @click="submitRanking">確 定</el-button>
				</div>
			</el-dialog>
			<el-dialog :close-on-click-modal="false"  :title="editPrizeIndex==-1?'添加獎品':'修改獎品'" :visible.sync="createPrizeModel" 
			top="5vh" :width="layout.is_phone?'90%':'50%'">
			<div style="max-height: 65vh; overflow: auto;">
				<!-- 表單内容 -->
				<el-form ref="formPrize" :rules="rulesPrize" :model="formPrize" :label-width="layout.is_phone?'80px':'100px'" :label-position="layout.is_phone?'top':'left'">
				
					<el-form-item label="獎品名稱" prop="name">
						<el-input type="text" v-model="formPrize.name" 
						placeholder="獎品名稱" 
						maxlength="20"  
        				show-word-limit  
						clearable size="small" style="width: 85%;">
						</el-input>
					</el-form-item>

					<el-form-item label="金額" prop="money">
						<el-input type="number" v-model="formPrize.money" 
						placeholder="金額" 
						clearable size="small" style="width: 85%;">
						</el-input>
					</el-form-item>
					
					<el-form-item label="郵費" prop="postage">
						<el-input type="number" v-model="formPrize.postage" 
						placeholder="郵費" 
						clearable size="small" style="width: 85%;">
						</el-input>
					</el-form-item>

					<el-form-item label="獎品簡介" prop="content">
						<el-input type="text" v-model="formPrize.content"
						maxlength="100"  
        				show-word-limit  
						placeholder="獎品簡介" 
						clearable size="small" style="width: 85%;">
						</el-input>
					</el-form-item>
				</el-form>
			</div>
				<div slot="footer" class="dialog-footer">
					<el-button @click="resetPrizeForm">取 消</el-button>
					<el-button type="primary" @click="submitPrize">確 定</el-button>
				</div>
			</el-dialog>
			<el-dialog :close-on-click-modal="false"  :before-close="handleClose" title="試卷" :visible.sync="createPaperModel" top="5vh" :width="layout.is_phone?'90%':'80%'">
				<div style="max-height: 65vh; overflow: auto;">
				<!-- 表單内容 -->
				<el-form ref="formPaper" :model="formPaper" :label-width="layout.is_phone?'80px':'130px'">
					<el-form-item label="組別名稱" prop="name"><el-input v-model="formPaper.name" placeholder="組別名稱" maxlength="10" show-word-limit clearable size="small" style="width: 85%;"></el-input></el-form-item>
					<el-form-item label="年級" prop="grade_id"	>
										<el-select v-model="formPaper.grade_id" style="width: 85%;" multiple filterable placeholder="請選擇">
											<el-option
											v-for="item in processedGradeList"
											:key="item.id"
											:label="item.name"
											:disabled="item.disabled"
											:value="item.id">
											</el-option>
										</el-select>
									</el-form-item>
									<el-form-item label="比賽時間" size="small" prop="timeArr">
							<el-date-picker
								v-model="formPaper.timeArr"
								type="datetimerange"
								range-separator="至"
								start-placeholder="開始時間"
								end-placeholder="結束時間"
								value-format="yyyy-MM-dd HH:mm:ss"
								@change="handleTimeRangeChange"> <!-- 当比賽時間发生变化时触发 -->
							</el-date-picker>
							</el-form-item>

						<el-form-item label="最遲入場時間" size="small" prop="latest_time">
							<el-date-picker
								v-model="formPaper.latest_time"
								type="datetime"
								placeholder="選擇日期時間"
								value-format="yyyy-MM-dd HH:mm:ss"
								:disabled="!formPaper.timeArr || formPaper.timeArr.length === 0" 
								:picker-options="latestTimePickerOptions"
								@change="validateLatestTime"> <!-- 动态限制可选范围 -->
							</el-date-picker>
							</el-form-item>


					<el-form-item label="做題時長(分)" prop="time" ><el-input v-model="formPaper.time" clearable size="small" style="width: 85%;"></el-input></el-form-item>
					<el-form-item label="題目數量" ><el-input v-model="formPaper.count" disabled clearable size="small" style="width: 85%;"></el-input></el-form-item>
					<el-form-item label="總分" ><el-input v-model="formPaper.total_score" disabled clearable size="small" style="width: 85%;"></el-input></el-form-item>
					<el-form-item>
						<el-button @click="addTag(false)">添加題目</el-button>
						<el-upload
							style="display: inline-flex;margin-left: 20px;"
							action=""
							:before-upload="beforeUpload"
							:show-file-list="false"
							accept=".xlsx,.xls"
						>
							<el-button class="mr-2" type="warning" size="mini">點擊上傳Excel文件</el-button>
						</el-upload>
						<el-button @click="downloadTemplate" class="mr-2" type="success" size="mini">下載題目模版文件</el-button>
						<el-button @click="deleteTagAll" class="mr-2" type="danger" size="mini">清空所有題目</el-button>
					
					</el-form-item>
					
					<el-form-item label="題目" prop="topList">
						<el-table :data="formPaper.topList" border style="width: 100%" @selection-change="handleSelectionChange">
							<el-table-column align="center" type="index" width="50" label="題號">
								<template slot-scope="scope">
									<span>{{scope.$index+1}}</span>	
									<!-- <el-image 
										v-if="scope.row.img"
										style="width: 100px; height: 100px"
										src="" 
										:preview-src-list="[scope.row.img]">
									</el-image> -->
									<i
										v-if="scope.row.img"
										class="el-icon-picture"
										style="cursor: pointer;"
										@click="handlePreview(scope.row)"
										></i>

										<!-- 隐藏的 el-image，用来触发预览 -->
										<el-image
										ref="previewImage"
										style="display: none;"
										:src="previewSrc"
										:preview-src-list="[previewSrc]"
										></el-image>
								</template>
							</el-table-column>
							<el-table-column align="center" prop="title" label="題目"></el-table-column>
							<el-table-column align="center" prop="score" label="分數"></el-table-column>
							<el-table-column align="center" prop="option_a" label="選項a"></el-table-column>
							<el-table-column align="center" prop="option_b" label="選項b"></el-table-column>
							<el-table-column align="center" prop="option_c" label="選項c"></el-table-column>
							<el-table-column align="center" prop="option_d" label="選項d"></el-table-column>
							<el-table-column align="center" prop="answer_o" label="選擇題答案"></el-table-column>
							<el-table-column align="center" prop="answer" label="填空題答案"></el-table-column>
							<el-table-column align="center" prop="difficulty" label="難度"></el-table-column>
							<el-table-column align="center" width="100"  prop="label_name" label="標籤">
								<template slot-scope="v">
									<span>
										<el-tag >{{v.row.label_name}}</el-tag>
									</span>
								</template>
							</el-table-column>
							
							<el-table-column align="center" width="80"  prop="topic_type"  label="類型">
								<template slot-scope="v">
									<el-tag v-if="v.row.topic_type==1" type="success">選擇題</el-tag>
									<el-tag v-if="v.row.topic_type==2" >填空題</el-tag>
									<el-tag v-if="v.row.topic_type==3" >上傳題</el-tag>
								</template>
							</el-table-column>
							<el-table-column prop="id" align="center" width="140" label="操作">
								<template slot-scope="scope">
									<el-button-group>
										<el-button size="mini" plain type="primary" @click="addTag(scope)">操作</el-button>
										<el-button @click="deleteTag(scope)" v-auth="'delAdmin'" size="mini" plain type="danger">刪除</el-button>
									</el-button-group>
								</template>
							</el-table-column>
						</el-table>
					</el-form-item>
				</el-form>
			</div>
				<div slot="footer" class="dialog-footer">
					<el-button @click="resetPaperForm">取 消</el-button>
					<el-button type="primary" @click="submitPaper">確 定</el-button>
				</div>
			</el-dialog>


		
		</div>

		<div v-if="createModel == 1">
			<el-dialog :close-on-click-modal="false"  :visible.sync="updateRankNum" title="修改">
          <el-form :rules="rulesRankNum"  ref="formRank" :model="formRank" :label-width="layout.is_phone?'80px':'130px'">
            <el-form-item label="組別名稱" prop="name">
                  <el-input v-model="formRank.name" disabled size="small" 
                  style="width: 85%;"></el-input>
              </el-form-item>
              <el-form-item label="榜單顯示人數" prop="num">
                  <el-input v-model="formRank.num"  size="small" 
                  style="width: 85%;"></el-input>
              </el-form-item>
          </el-form>

            <div slot="footer" class="dialog-footer">
              <el-button @click="updateRankNum = false">取 消</el-button>
              <el-button type="primary" @click="submitRankNum">確 定</el-button>
          </div>
          </el-dialog>

			<el-dialog :close-on-click-modal="false"  title="添加機器人" :visible.sync="createRobotModel" 
				top="5vh" :width="layout.is_phone?'90%':'60%'">
					<!-- 表單内容 -->
					<el-form  :rules="rules" ref="formEdit" :model="formRobot" :label-width="layout.is_phone?'100px':'150px'" :label-position="layout.is_phone?'top':'left'">
						<el-form-item label="剩餘機器人數量" >
							<span>{{robotNum}}</span>
						</el-form-item>
						<el-form-item label="已添加機器人數量" >
							<span>{{robotInNum}}</span>
						</el-form-item>

						<el-form-item label="機器人數量" prop="num">
							<el-input type="number" v-model="formRobot.num" 
							placeholder="機器人數量" 
							clearable size="small" style="width: 85%;">
							</el-input>
						</el-form-item>
						
					</el-form>

					<div slot="footer" class="dialog-footer">
						<el-button @click="createRobotModel = false">取 消</el-button>
						<el-button type="primary" @click="submitRobot">確 定</el-button>
					</div>
				</el-dialog>
			<div class="mb-2 mt-2 pt-3">
			<template>
				<el-header style="float: left;">{{ com_info.com_no  }} - {{ com_info.title  }}</el-header>
			</template>
			<div style="float: right;">
				<el-button @click="resetForm">返 回</el-button>
				<!-- <el-button type="primary" @click="submit">發佈成績</el-button> -->
			</div>
			</div>
			<div slot="footer" style="text-align: center; padding: 10px 0 30px 0">
			
			</div>
			<el-form
			ref="form"
			:model="form"
			:label-width="layout.is_phone ? '80px' : '100px'"
			>
			<el-form-item prop="groupList">
				<el-table
					:data="groupList"
					border
					style="width: 100%"
					@selection-change="handleSelectionChange"
					:row-class-name="tableRowClassName" 
				>
					<el-table-column
					align="center"
					prop="name"
					label="組別名稱"
					></el-table-column>
	
					<el-table-column
					align="center"
					prop="total_score"
					label="試卷總分"
					></el-table-column>
	
					<el-table-column
                align="center"
                prop="participant_count"
                label="參賽人數"
                ></el-table-column>


                <el-table-column
                align="center"
                prop="paper_count"
                label="比賽人數"
                ></el-table-column>
	
					<el-table-column
					align="center"
					prop="average"
					label="平均分"
					></el-table-column>
	
					<el-table-column
					align="center"
					prop="median"
					label="中位數"
					></el-table-column>
	
					<el-table-column
					align="center"
					prop="check_count"
					label="未改試卷"
					></el-table-column>
	
					<el-table-column
					align="center"
					prop="time"
					label="時長限制"
					></el-table-column>
	
					<el-table-column
					align="center"
					label="榜單顯示人數"
					>
					<template slot-scope="v">
						<el-button @click="startEditing(v)" :disabled="com_info.start_status !== 3"  v-auth="'delRule'" size="mini" plain type="warning">{{ v.row.rank_num }}</el-button>
					</template>
					</el-table-column>
	
					<el-table-column prop="id" align="center" width="360" label="操作">
					<template slot-scope="scope">
						<el-button-group>
							<el-button
								size="mini"
								plain
								type="primary"
								@click="addRanking(scope.row.id)"
								>查看</el-button>
							<el-button
							size="mini"
							plain
							type="warning"
							@click="checkCharts(scope.row.id)"
							>圖表</el-button>
							<el-button
							size="mini"
							plain
							type="success"
							@click="checkTopic(scope.row.id)"
							>試卷</el-button>
							
												
														<el-button
															size="mini"
															plain
															type="danger"
															@click="setRobot(scope.row.id)"
															>添加機器人</el-button
														>
														
														<el-button size="mini" v-if="com_info.start_status == 4" plain type="warning" @click="openPrizeModel(scope.row)">購買獎品</el-button>
							<el-button v-if="com_info.start_status == 0 || com_info.start_status == 1" size="mini" plain type="primary" @click="setStudentLists(scope.row)">幫忙報名</el-button>
						</el-button-group>
					</template>
					</el-table-column>
				</el-table>
			</el-form-item>
	
			<div class="mb-2 mt-2 pt-3">
			
			<button-search
				:isphone="layout.is_phone"
				ref="buttonSearch"
				placeholder="搜索學生名稱"
				@search="searchEventTopic"
				:showGj="true"
			>
				<template #left>
				<el-button type="primary" v-if="com_info.start_status == 3" style="margin-right: 20px;" v-auth="'view'+auth_val" @click="queue" size="mini">快速排名</el-button>
				<el-button type="primary" @click="export_excel" style="margin-right: 20px;" size="mini">導出數據</el-button>
				<el-tag  v-for="item in formQueue" :key="item.id" >{{item.level_name}}: {{item.num}}</el-tag>
				</template>
				<template #from>
				<el-form inline ref="form" :model="fromTopic" label-width="100px">
					<el-form-item label="學生名稱" class="mb-0">
					<el-input
						size="small"
						v-model="fromTopic.name"
						placeholder="搜索學生名稱"
					></el-input>
					</el-form-item>

					<el-form-item label="學生編號" class="mb-0">
					<el-input
						size="small"
						v-model="fromTopic.user_no"
						placeholder="搜索學生編號"
					></el-input>
					</el-form-item>
	
					<el-form-item label="學校名稱" class="mb-0">
					<el-input
						size="small"
						v-model="fromTopic.school_name"
						placeholder="搜索學校名稱"
					></el-input>
					</el-form-item>
	
					<el-form-item label="學生郵件" class="mb-0">
					<el-input
						size="small"
						v-model="fromTopic.email"
						placeholder="搜索學生郵件"
					></el-input>
					</el-form-item>
	
	
					<el-form-item class="mb-0">
					<el-button type="info" @click="searchEventTopic" size="small"
						>搜索
					</el-button>
					<el-button size="small" @click="clearSearchTopic"
						>清空篩選條件</el-button
					>
					</el-form-item>
	
					
				</el-form>
				</template>
			</button-search>
			</div>
	
			<!-- 表格 -->
			<div class="mt-3 pt-2">
			<el-table
				:data="userTopicList"
				border
				style="width: 100%"
				@sort-change="handleSortChange"
				:default-sort = "{prop: 'rank', order: 'ascending'}"
			>
				<el-table-column align="center" width="80" sortable prop="rank" label="排名">
				</el-table-column>
				
				<el-table-column align="center" prop="join_no" label="參加編號">
				</el-table-column>
						
				<el-table-column align="center" prop="topic_no"  width="200"  label="試卷編號">
				</el-table-column>
					

				<el-table-column align="center" prop="user_no" label="學生編號">
				</el-table-column>
				<el-table-column align="center" prop="name" label="學生名稱">
				</el-table-column>
				<el-table-column align="center" prop="school_name" label="學校名稱">
				</el-table-column>
			
				<el-table-column align="center" sortable prop="score" label="成績">
				</el-table-column>
				<el-table-column align="center" prop="yes_num" label="答對數量">
				</el-table-column>
				<el-table-column align="center" prop="use_time_text" label="做題時長">
				</el-table-column>
				<el-table-column align="center" prop="end_time" label="交卷時間">
				</el-table-column>
				<el-table-column align="center" prop="level_id" label="名次">
				<template slot-scope="scope">
					<el-select 
					v-model="scope.row.level_id" 
					placeholder="請選擇" 
					@change="handleLevelChange(scope.row)"
					:disabled="!scope.row.is_none || com_info.start_status !== 3">
					<el-option
						v-if="!scope.row.is_none"
						:key="'absent'"
						label="缺席"
						:value="0">
					</el-option>
					<el-option
						v-else
						:key="'unselected'"
						label="未選擇"
						:value="0">
					</el-option>
					<el-option
						v-for="item in formQueue"
						:key="item.id"
						:label="item.level_name"
						:value="item.id">
					</el-option>
					</el-select>
				</template>
				</el-table-column>

				
				<el-table-column prop="id" align="center" width="120" label="操作">
					<template slot-scope="scope">
					<el-button-group>
						<el-button
						v-if="!scope.row.is_none || com_info.start_status !== 3"
						size="mini"
						disabled
						plain
						type="info"
						v-auth="'view' + auth_val"
						>修改分數</el-button
						>
						<el-button
						v-else
						size="mini"
						plain
						type="primary"
						v-auth="'view' + auth_val"
						@click="updateTopic(scope.row)"
						>修改分數</el-button
						>
					</el-button-group>
					</template>
				</el-table-column>
			</el-table>
			<el-footer
				class="d-flex bg-white align-items-center px-0"
				style="float: right;"
			>
				<!-- 底部 -->
	
				<div style="flex: 1" class="px-2">
					<el-pagination
						:current-page="pageScore.current"
						:page-sizes="pageScore.sizes"
						:page-size="pageScore.size"
						@size-change="handleScoreSizeChange"
						@current-change="handleScoreCurrentChange"
						layout="total, sizes, prev, pager, next, jumper"
						:total="pageScore.total"
					>
					</el-pagination>
				</div>
			</el-footer>
			</div>
	
			<el-dialog :close-on-click-modal="false"  title="題目" :visible.sync="checkTopicModel" top="5vh" :width="layout.is_phone?'90%':'80%'">
				<template>
					<el-table :data="dialog_list"  max-height="550" border style="width: 100%"  :row-class-name="tableRowClassName">
						
						<el-table-column align="center" prop="topic_no" label="題目編號">
						</el-table-column>
						<el-table-column align="center" prop="title" label="題目">
							<template slot-scope="scope">
								<div v-if="scope.row.title.length > 20">
									{{ scope.row.title.substring(0, 20) }}... 
									<el-button type="text" @click="showFullTitle(scope.row.title)">點擊查看</el-button>
								</div>
								<div v-else>
									{{ scope.row.title }}
								</div>
							</template>
						</el-table-column>
						<el-table-column align="center" prop="yes"  label="正確答案">
							<template slot-scope="scope">
								<div v-if="scope.row.topic_type == 1">
														{{ scope.row.yes }}
													</div>
													<div v-else>
														
													</div>
												</template>
						</el-table-column>
						<el-table-column align="center" width="200" label="選項">
												<template slot-scope="scope">
													<div v-if="scope.row.topic_type == 1">
														<span v-for="(item, index) in scope.row.xuan" :key="index">
															{{ index }}：{{ item }}<br>
														</span>
													</div>
													<div v-else>
														
													</div>
												</template>
											</el-table-column>
	
						<el-table-column align="center"  prop="label_name"  label="標籤">
							<template slot-scope="v">
								<span>
									<el-tag type="warning">{{v.row.label_name}}</el-tag>
								</span>
							</template>
						</el-table-column>
	
	
						<el-table-column align="center"  prop="score" label="分數">
						</el-table-column>
						<el-table-column align="center"  prop="difficulty" label="難度">
						</el-table-column>
	
						<el-table-column align="center"  prop="total" label="答題人數">
						</el-table-column>
	
						<el-table-column align="center"  prop="correct" label="答對人數">
						</el-table-column>
						
						<el-table-column align="center"  prop="percentage" label="答對百分比">
						</el-table-column>
					</el-table>
				</template>
			</el-dialog>
	
			<el-dialog :close-on-click-modal="false"  title="圖表" :visible.sync="chartsModel" top="5vh" :width="layout.is_phone ? '90%' : '80%'" @open="initChart">
			<!-- 圖表内容 -->
			<div class="testbg">
				<el-row :gutter="layout.index_p.gutter" class=" h_l">
					<!-- 左边 -->
					<el-col :span="24" class="pb-4 h_100">
						<el-card class="box-card h_100 new_card" shadow="hover">
							<div slot="header" class="clearfix">
								<span>成績分佈</span>
							</div>
							<!-- 统计图容器 -->
							<div ref="myChart" style="width: 100%; height: 270px;"></div>
						</el-card>
					</el-col>
				</el-row>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="chartsModel = false">關 閉</el-button>
			</div>
		</el-dialog> 
	
			
			</el-form>
			<div slot="footer" style="text-align: center; padding: 30px 0 30px 0">
			
			</div>
	
			<el-dialog :close-on-click-modal="false"  title="修改名次" :visible.sync="createQueueModel" top="5vh" :width="layout.is_phone?'90%':'50%'">
			<!-- 表單内容 -->
			<el-form ref="form" :model="formQueue" :label-width="layout.is_phone ? '80px' : '100px'">
				<div v-for="item in formQueue" :key="item.id">
				<el-form-item :label="item.level_name" :prop="`score_${item.id}`">
					<el-input
					v-model="item.minScore"
					placeholder="最低分數"
					clearable
					size="small"
					type="number"
					style="width: 40%; display: inline-block;"
					></el-input>
					<span style="margin: 0 10px;">-</span>
					<el-input
					v-model="item.maxScore"
					placeholder="最高分數"
					clearable
					size="small"
					type="number"
					style="width: 40%; display: inline-block;"
					></el-input>
					<span v-if="item.scoreWarning" style="color: red;">{{ item.scoreWarning }}</span> <!-- 顯示错误信息 -->
				</el-form-item>
				</div>
			</el-form>
	
			<div slot="footer" class="dialog-footer">
				<el-button @click="createQueueModel = false">取 消</el-button>
				<el-button type="primary" @click="submitQueue">確 定</el-button>
			</div>
			</el-dialog>
		
	
			<el-dialog :close-on-click-modal="false"  title="修改成績" :visible.sync="createTopicModel" top="5vh" :width="layout.is_phone?'90%':'50%'">
				<!-- 表單内容 -->
				<el-form ref="form" :model="formTopic" :label-width="layout.is_phone?'80px':'100px'">
	
					<el-form-item label="學生姓名" prop="name">
						<el-input v-model="formTopic.name" disabled size="small" 
						style="width: 85%;"></el-input>
					</el-form-item>
					<el-form-item label="學校" prop="school_name">
						<el-input v-model="formTopic.school_name" disabled size="small"
						style="width: 85%;"></el-input>
					</el-form-item>
					<el-form-item label="郵箱" prop="email">
						<el-input v-model="formTopic.email" disabled size="small" style="width: 85%;"></el-input>
					</el-form-item>
	
			<el-form-item label="目前排名" prop="rank">
						<el-input v-model="formTopic.rank"   size="small" style="width: 85%;"></el-input>
					</el-form-item>
	
					<el-form-item label="分數" prop="score">
						<el-input v-model="formTopic.score" placeholder="為空預設0" clearable size="small" style="width: 85%;"></el-input>
					</el-form-item>
					
					<el-form-item label="做題時長" prop="use_time">
						<el-input v-model="formTopic.use_time" placeholder="為空預設0" clearable size="small" style="width: 85%;"></el-input>
					</el-form-item>
				</el-form>
	
	
				<div slot="footer" class="dialog-footer">
					<el-button @click="createTopicModel = false">取 消</el-button>
					<el-button type="primary" @click="submitTopic">確 定</el-button>
				</div>
			</el-dialog>

			
		</div>
	
		<div v-if="createModel == 0">
			<div class="mb-2 mt-2 pt-3">
					<button-search :isphone="layout.is_phone" ref="buttonSearch" placeholder="搜索 比賽名稱" @search="searchEvent" :showGj="true">
						<!-- 高級搜索 1-->
						<template #from>
							<el-form inline ref="form" :model="from" label-width="100px">
								<el-form-item label="比賽名稱" class="mb-0">
									<el-input size="small" v-model="from.title" placeholder="搜索比賽名稱"></el-input>
								</el-form-item>


								<el-form-item label="比賽編號" class="mb-0">
									<el-input size="small" v-model="from.com_no" placeholder="比賽編號"></el-input>
								</el-form-item>

								<el-form-item label="機構名稱" class="mb-0">
									<el-input size="small" v-model="from.ins_name" placeholder="機構名稱"></el-input>
								</el-form-item>
								
								<el-form-item label="是否收費" class="mb-0">
									<el-select v-model="from.pay_type" size="small" >
										<el-option label="全部" :value=-1></el-option>
										<el-option label="免費" value="1"></el-option>
										<el-option label="收費" value="2"></el-option>
									</el-select>
								</el-form-item>
							
								<el-form-item label="比賽人選" class="mb-0">
									<el-select v-model="from.is_school" size="small" >
										<el-option label="全部" value="-1"></el-option>
										<el-option label="無限制" value="0"></el-option>
										<el-option label="非學校用戶" value="1"></el-option>
										<el-option label="學校用戶" value="2"></el-option>
									</el-select>
								</el-form-item>
								
								<el-form-item label="創建時間" size="small" class="mb-0">
									<el-date-picker v-model="from.time" type="daterange" align="right" unlink-panels value-format="yyyy-MM-dd"
									range-separator="至" start-placeholder="開始日期" end-placeholder="結束日期" :picker-options="pickerOptions">
									</el-date-picker>
								</el-form-item>

								<el-form-item class="mb-0">
									<el-button type="info" @click="searchEvent" size="small">搜尋 </el-button>
									<el-button size="small" @click="clearSearch">清空篩選條件</el-button>
								</el-form-item>

							</el-form>
						</template>
					</button-search>
				</div>

				<!-- 表格 -->
				<div class="mt-3 pt-2">
					<el-table :data="tableData" @sort-change="sortChange" border style="width: 100%" @selection-change="handleSelectionChange">
						
						<el-table-column align="center" prop="com_no" label="比賽編號" width="100">
						</el-table-column>

						<el-table-column align="center" prop="title" label="比賽">
									<template slot-scope="scope">
										<!-- <div v-if="scope.row.title.length > 20">
											{{ scope.row.title.substring(0, 20) }}... 
											<el-button type="text" @click="showFullTitle(scope.row.title)">點擊查看</el-button>
										</div>
										<div v-else> -->
											{{ scope.row.title }}
										<!-- </div> -->
									</template>
						</el-table-column>

						<el-table-column align="center" prop="subject_name" label="學科" width="100">
						</el-table-column>
						
						
						<el-table-column align="center" prop="status" label="顯示狀態" width="100">
							<template slot-scope="scope">
								<el-button
								:type="scope.row.status ? 'success' : 'danger'" 
								size="mini"
								@click="changeStatus(scope.row)"
								plain>{{scope.row.status ? '顯示' : '隱藏'}}
								</el-button>
							</template>
						</el-table-column>

						<el-table-column align="center" prop="pay_type" label="報名費@"  width="180">
							<template slot-scope="v">
									<span  class="text-warning" v-if="v.row.pay_type==1">免費</span>
									<span v-if="v.row.pay_type==2"><i class="text-success" >學校用戶</i> : <span class="money_text">{{v.row.money}}</span> <br> <i class="text-primary" >非學校用戶</i> : <span class="money_text">{{v.row.no_school_money}}</span></span>
								</template>
						</el-table-column>				
						
						<el-table-column align="center" prop="ins_name" label="機構名稱">
						</el-table-column>
						
						<el-table-column align="center" prop="total_user" label="報名人數" width="100">
						</el-table-column>

						<el-table-column align="center" prop="prize_count" label="訂單數" width="100">
							<template slot-scope="scope">
								<span :class="scope.row.prize_count > 0 ? 'text-success' : ''">{{ scope.row.prize_count || 0 }}</span>
								<span @click="openExl(scope.row.id, scope.row.title)" v-if="scope.row.prize_count > 0" style="margin-left: 5px; cursor: pointer;">(<i style="color: #007bff;">導出</i>)</span>
							</template>
						</el-table-column>

						<el-table-column align="center" prop="apply_status" label="報名進度" width="100">
								<template slot-scope="v">
									<span  class="text-warning" v-if="v.row.apply_status==0">未開始</span>
									<span class="text-success" v-if="v.row.apply_status==1">進行中</span>
									<span class="text-danger" v-if="v.row.apply_status==2">已結束</span>
								</template>
						</el-table-column>

						<el-table-column align="center" prop="start_status" label="比賽進度" width="100">
								<template slot-scope="v">
									<span  class="text-warning" v-if="v.row.start_status==0">未開始</span>
									<span class="text-success" v-if="v.row.start_status==1">進行中</span>
									
									<span class="text-primary" v-if="v.row.start_status==2">待公佈</span>
									<span class="text-primary" v-if="v.row.start_status==3">待公佈</span>

									<span class="text-danger" v-if="v.row.start_status==4">已公佈</span>
									<span class="text-secondary" v-if="v.row.start_status==5">已關閉</span>
								</template>
						</el-table-column>

						<el-table-column align="center" prop="audit_status" label="公佈狀態" width="100">
								<template slot-scope="v">
								
									<span  class="text-warning" v-if="v.row.audit_status==4">未處理</span>
									<span  class="text-warning" v-if="v.row.audit_status==0">評分中</span>
									<span class="text-primary" v-if="v.row.audit_status==1">覆核中</span>
									<span class="text-success" v-if="v.row.audit_status==2">已公佈</span>
									<span class="text-danger" v-if="v.row.audit_status==3">機構覆檢</span>
									<span class="text-danger" v-if="v.row.audit_status==5">待公佈</span>
								</template>
						</el-table-column>

						<el-table-column align="center" prop="prize_end_status" label="訂購狀態" width="100">
							<template slot-scope="v">
									<span  class="text-warning" v-if="v.row.prize_end_status==0">未開始</span>
									<span class="text-success" v-if="v.row.prize_end_status==1">進行中</span>
									<span class="text-danger" v-if="v.row.prize_end_status==2">已結束</span>
								</template>
						</el-table-column>

						<el-table-column prop="id" :fixed="this.layout.is_phone?false:'right'" align="center" width="280" label="操作">
							<template slot-scope="scope">
								<el-button-group>
									<el-button v-auth="'view'+auth_val" size="mini" plain type="success" @click="openModels(scope.row.id,scope.row.start_status)">查看</el-button>
									<el-button v-auth="'view'+auth_val" size="mini" plain type="primary" @click="openModel(scope.row.id)">參賽</el-button>
									<el-button size="mini" plain type="warning" @click="openFenModel(scope.row)">分組</el-button>
									<el-button size="mini" plain type="success" @click="openSchool(scope.row)">學校排名</el-button>
								</el-button-group>
							</template>
						</el-table-column>



						<el-table-column align="center" prop="create_time" width="160" label="創建時間">
						</el-table-column>
					</el-table>
				</div>

				<div style="height: 60px;"></div>
				<el-footer class="d-flex border-top bg-white align-items-center px-0 position-fixed all_foot_page" >
					<!-- 底部 -->

					<div style="flex: 1;" class="px-2">
						<el-pagination :current-page="page.current" :page-sizes="page.sizes" :page-size="page.size" @size-change="handleSizeChange"
						@current-change="handleCurrentChange" layout="total, sizes, prev, pager, next, jumper" :total="page.total">
						</el-pagination>
					</div>
				</el-footer>
		</div>

		<!-- 分組弹框 -->
		<el-dialog
			:visible.sync="FenGroupModel"
			:width="layout.is_phone?'90%':'90%'"
			:before-close="hideFenGroupModel"
			:title="FenGroupTitle"
			v-loading="layout.loading">
			<div class="mt-3 pt-2">
				<el-table :data="tableFenData" border style="width: 100%">
					<el-table-column align="center" prop="name" label="組別名稱"></el-table-column>
					<el-table-column align="center" prop="registration_count" label="報名人數">
						<template slot-scope="scope">
							<span :class="scope.row.registration_count > 0 ? 'text-success' : ''">{{ scope.row.registration_count }}</span>
						</template>
					</el-table-column>
					<el-table-column align="center" prop="com_money" label="報名金額">
						<template slot-scope="scope">
							<span :class="scope.row.com_money > 0 ? 'money_text' : ''">{{ scope.row.com_money }}</span>
						</template>
					</el-table-column>
					<el-table-column align="center" prop="prize_count" label="購買獎品人數">
						<template slot-scope="scope">
							<span :class="scope.row.prize_count > 0 ? 'text-success' : ''">{{ scope.row.prize_count }}</span>
						</template>
					</el-table-column>
					<el-table-column align="center" prop="prize_money" label="購買獎品金額">
						<template slot-scope="scope">
							<span :class="scope.row.prize_money > 0 ? 'money_text' : ''">{{ scope.row.prize_money }}</span>
						</template>
					</el-table-column>
					<el-table-column align="center" prop="order_count" label="訂單數">
						<template slot-scope="scope">
							<span :class="scope.row.order_count > 0 ? 'text-success' : ''">{{ scope.row.order_count }}</span>
						</template>
					</el-table-column>
					<el-table-column align="center" prop="order_money" label="訂單金額">
						<template slot-scope="scope">
							<span :class="scope.row.order_money > 0 ? 'money_text' : ''">{{ scope.row.order_money }}</span>
						</template>
					</el-table-column>
					<el-table-column align="center" prop="submitted_count" label="交卷人數">
						<template slot-scope="scope">
							<span :class="scope.row.submitted_count > 0 ? 'text-success' : ''">{{ scope.row.submitted_count }}</span>
						</template>
					</el-table-column>
					<el-table-column align="center" prop="checked_count" label="查看成績人數"></el-table-column>
				</el-table>
			</div>
			<template #footer>
				<el-button @click="hideFenGroupModel">關閉</el-button>
			</template>
		</el-dialog>

		<!-- 學習排名（學校排名）弹框 -->
		<el-dialog
			:visible.sync="SchoolModel"
			:width="layout.is_phone?'90%':'90%'"
			:before-close="hideSchoolModel"
			:title="FenGroupTitle"
			v-loading="layout.loading">
			<div class="mt-3 pt-2">
				<el-table :data="SchoolData" border style="width: 100%">
					<el-table-column align="center" prop="school_name" label="學校名稱"></el-table-column>
					<el-table-column align="center" prop="com_count" label="報名人數">
						<template slot-scope="scope">
							<span :class="scope.row.com_count > 0 ? 'text-success' : ''">{{ scope.row.com_count || 0 }}</span>
						</template>
					</el-table-column>
					<el-table-column align="center" prop="submit_count" label="交卷人數">
						<template slot-scope="scope">
							<span :class="scope.row.submit_count > 0 ? 'text-success' : ''">{{ scope.row.submit_count || 0 }}</span>
						</template>
					</el-table-column>
					<el-table-column
						v-for="(item, index) in dynamicColumns"
						:key="index"
						:label="item.level_name"
						align="center">
						<template slot-scope="scope">
							<span :class="scope.row[item.level_name] > 0 ? 'text-success' : ''">{{ scope.row[item.level_name] || 0 }}</span>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<template #footer>
				<el-button @click="hideSchoolModel">關閉</el-button>
			</template>
		</el-dialog>
	  
		<el-dialog
			:visible.sync="FenModel"
			:width="layout.is_phone?'90%':'90%'"
			:before-close="hideFenModel"
			
			 v-loading="layout.loading"
			>
			
			<div class="mt-3 pt-2" v-if="tablePrizeData.length>0">
				<!-- 左边 -->
				<template>
					<div style="font-size: 20px;text-align: center;margin-bottom: 20px;">{{ prizeTitle }}</div>
				</template>

				<!-- 顶部選擇信息和提交按钮 -->
				<div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 10px;">
					<!-- 显示当前選擇的數量和总金额 -->
					<div>
						已選擇獎品數: {{ selectedPrizeCount }} ，合計支付金額: <span class="money_text">{{ totalPrizeAmount }}</span> 元
					</div>
					<div>
						<!-- 提交按钮 -->
						<!-- <el-button type="primary" @click="submitSelection(2)" :disabled="isSubmitting">支付</el-button> -->
						<el-button type="primary" @click="submitSelectionCart(2)" :disabled="isSubmitting">加入購物車</el-button>
					</div>
					
				</div>
					
				<!-- <div style="margin-bottom: 20px; padding: 10px; border: 1px solid #e4e4e4; border-radius: 5px;">
						<div style="margin-bottom: 10px; font-weight: bold;">選擇支付方式:</div>
						<el-radio-group v-model="selectedPaymentMethod">
							<el-radio label="paypal">PayPal</el-radio>
							<el-radio label="bank_transfer">銀行轉賬</el-radio>
						</el-radio-group>
					</div> -->

				<el-table :data="tablePrizeData"  :row-class-name="rowClassName" border style="width: 100%" @selection-change="handleSelectionPrizeChanges" ref="prizeTable">
					<el-table-column type="selection" width="45" align="center"></el-table-column>

					<el-table-column align="center" prop="prize_name" label="獎品名稱">
					</el-table-column>
					
					<el-table-column align="center" prop="content" label="獎品簡介">
								<template slot-scope="scope">
									<div v-if="scope.row.content.length > 20">
										{{ scope.row.content.substring(0, 20) }}... 
										<el-button type="text" @click="showFullTitle(scope.row.content)">点击查看</el-button>
									</div>
									<div v-else>
										{{ scope.row.content }}
									</div>
								</template>
					</el-table-column>
					<el-table-column align="center" prop="money"  label="價格">
						<template slot-scope="scope">
							<span :class="scope.row.money> 0 ? 'money_text' : ''">{{ scope.row.money }}</span>
						</template>
					</el-table-column>
					<el-table-column align="center" prop="postage"  label="郵費">
						<template slot-scope="scope">
							<span :class="scope.row.postage> 0 ? 'money_text' : ''">{{ scope.row.postage }}</span>
						</template>
					</el-table-column>
					<el-table-column align="center" prop="rank_count"  label="獲獎人數">
						<template slot-scope="scope">
							<span :class="scope.row.rank_count> 0 ? 'text-success' : ''">{{ scope.row.rank_count }}</span>
						</template>
					</el-table-column>
					<el-table-column align="center" prop="pay_count"  label="已購買人數">
						<template slot-scope="scope">
							<span :class="scope.row.pay_count> 0 ? 'text-success' : ''">{{ scope.row.pay_count }}</span>
						</template>
					</el-table-column>
					<el-table-column align="center" prop="userCount"  label="已選擇人數">
						<template slot-scope="scope">
							<span :class="scope.row.userCount> 0 ? 'text-success' : ''">{{ scope.row.userCount }}</span>
						</template>
					</el-table-column>
					<el-table-column align="center" prop="prizeMoney"  label="應付金額">
						<template slot-scope="scope">
							<span :class="scope.row.prizeMoney> 0 ? 'text-success' : ''">{{ scope.row.prizeMoney }}</span>
						</template>
					</el-table-column>
					<el-table-column prop="id" align="center" width="160" label="操作">
						<template slot-scope="scope">
							<el-button-group>
								<el-button size="mini" plain type="warning" @click="openOrderModel(scope.row)">訂購</el-button>
							</el-button-group>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<template #footer>
				<el-button @click="hideFenModel">關閉</el-button>
			</template>
		</el-dialog>

		<el-dialog
				:close-on-click-modal="false"
				:title="prizeUserTitle"
				:visible.sync="pyaOrderModel"
				top="5vh"
				:width="layout.is_phone ? '90%' : '80%'"
				v-loading="payloading"
				element-loading-text="支付中......"
				element-loading-parent
				>
				
				<!-- 顶部選擇信息和提交按钮 -->
				<div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 10px;">
					<!-- 顯示當前選擇的數量和總金額 -->
					<div>
					已選擇人數: {{ selectedCount }} 人，合計支付金額: <span class="money_text">{{ totalAmount }}</span> 元
					</div>
					<!-- 提交按钮 -->
					<el-button type="primary" @click="submitSelectionPrize(2)" :disabled="isSubmitting">添加</el-button>
				</div>
				
				<!-- 表單内容 -->
				<el-table :data="dialog_suer_pay_list" ref="userTable" border style="width: 100%" @selection-change="handleSelectionChanges">
					<el-table-column type="selection" width="45" align="center"></el-table-column>
					<el-table-column align="center" prop="user_no" label="學生編號"></el-table-column>
					<el-table-column align="center" prop="school_name" label="學校名稱"></el-table-column>
					<el-table-column align="center" prop="name" label="學生名稱"></el-table-column>
					<el-table-column align="center" prop="g_name" label="年級"></el-table-column>
					<el-table-column align="center" prop="class_id" label="班別"></el-table-column>
					<el-table-column align="center" prop="number" label="學號"></el-table-column>
					<el-table-column align="center" prop="money" width="50" label="價格"></el-table-column>
					<el-table-column align="center" prop="postage" width="50" label="郵費"></el-table-column>
					<el-table-column align="center" prop="pay_moeny" label="應付金額"></el-table-column>
				</el-table>
			</el-dialog>

			
		<el-dialog  :close-on-click-modal="false"  title="添加學生" :visible.sync="createUserModel" 
			
			top="5vh" :width="layout.is_phone?'90%':'60%'" v-loading="payloading" element-loading-text="加載中......">
			<div style="max-height: 65vh; overflow: auto;">
			<div class="mb-2 mt-2 pt-3">
					<!-- 高級搜索 1-->
					<template >
						<el-form inline ref="form" :model="fromUser" label-width="100px">
							<el-form-item label="學生編號" class="mb-0">
								<el-input size="small" v-model="fromUser.user_no" placeholder="學生編號"></el-input>
							</el-form-item>


							<el-form-item label="學生名稱" class="mb-0">
								<el-input size="small" v-model="fromUser.name" placeholder="學生名稱"></el-input>
							</el-form-item>

							<el-form-item label="班別" class="mb-0">
								<el-input size="small" v-model="fromUser.class_id" placeholder="班別"></el-input>
							</el-form-item>
							
							<el-form-item label="學校" class="mb-0">
								<el-input size="small" v-model="fromUser.school_name" placeholder="學校"></el-input>
							</el-form-item>
							

							<el-form-item class="mb-0">
								<el-button type="info" @click="searchEventUser" size="small">搜尋 </el-button>
								<el-button size="small" @click="clearSearchUser">清空篩選條件</el-button>
							</el-form-item>
						</el-form>
					</template>
			</div>

				<!-- 顶部選擇信息和提交按钮 -->
				<div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 10px;">
					<!-- 顯示當前選擇的數量和總金額 -->
					<div>
						已選擇人數: {{ selectedCount }} 人<span v-if="pay_type == 2">，<span v-if="com_info.discount_code"> 小計: <span class="money_text">{{ totalAmount }}</span> 元，</span>優惠金額: <span class="money_text">{{ totalDiscount }}</span> 元，</span>合計支付金額: <span class="money_text">{{ totalPayAmount }}</span> 元
					</div>
					<!-- 提交按钮 -->
					<!-- <el-button type="primary" @click="submitSelection(1)" :disabled="isSubmitting">報名</el-button> -->
					<el-button type="primary" @click="submitSelectionCart(1)" :disabled="isSubmitting">加入購物車</el-button>
				</div>
				<div v-if="pay_type == 2" style="margin-bottom: 20px; padding: 10px; border: 1px solid #e4e4e4; border-radius: 5px;">
					<!-- <div style="margin-bottom: 10px; font-weight: bold;">選擇支付方式:</div>
					<el-radio-group v-model="selectedPaymentMethod" style="vertical-align: baseline;">
						<el-radio label="paypal">PayPal</el-radio>
					
						<el-radio label="bank_transfer">銀行轉賬</el-radio>
					</el-radio-group> -->
					<el-input placeholder="請輸入優惠碼" v-if="com_info.discount_code" style="width: 300px;margin-left: 30px;" min v-model="input1" @input="handleInput">
						<template slot="prepend">優惠碼</template>
					</el-input>
				</div>
					
				<!-- 表單内容 -->
					<el-table :data="dialog_suer_pay_list" border style="width: 100%" @selection-change="handleSelectionChanges">

						<el-table-column type="selection" width="45" align="center">
						</el-table-column>
									
						<el-table-column align="center" prop="user_no" label="學生編號">
						</el-table-column>

						<el-table-column align="center" prop="name" label="學生名稱">
						</el-table-column>
					
						<el-table-column align="center" prop="school_name" label="學校名稱">
						</el-table-column>

						<el-table-column align="center" prop="g_name" label="年級">
						</el-table-column>

						<el-table-column align="center" prop="class_id" label="班別">
						</el-table-column>

						<el-table-column align="center" prop="number" label="學號">
						</el-table-column>
						
						<el-table-column align="center" prop="money" label="支付金額">
						</el-table-column>

				</el-table>
			
			</div>
			</el-dialog>
	  
	  <el-dialog :close-on-click-modal="false"  :visible.sync="dialogTitleVisible" title="比賽">
			<p>{{ fullTitle }}</p>
		</el-dialog>


	  <!-- 弹出框，用于顯示完整題目 -->
		  <el-dialog :close-on-click-modal="false"  :visible.sync="dialogVisible" title="題目">
		  <p>{{ fullTitle }}</p>
		  </el-dialog>
		
	</div>
  </template>
  
  <script>
  import { commondecrypt } from "@/main";
  import XLSX from 'xlsx';
  import common from "@/common/mixins/common.js";
  import buttonSearch from "@/components/common/button-search.vue";
  import { mapState } from 'vuex';
  import echarts from 'echarts'
  export default {
	components: {
	  buttonSearch
	},
	inject: ["layout", "app"],
	mixins: [common],
	data() {
	  return {
		latestTimePickerOptions: {}, // 最遲入場時間的动态限制
		submitLoading:false,
		createPrizeModel: false,
		editPrizeIndex: -1,
		createUserModel:false,
		formPrize:{
					name:'',
					money:0,
					postage:0,
					content:'',
				},
		rulesPrize: {
					name: [{
							required: true,
							message: "獎品名稱不能為空",
							trigger: 'blur',
						},
					],
					content: [{
							required: true,
							message: "獎品備註不能為空",
							trigger: 'blur',
						},
					],
					
					money: [{
						required: true,
						message: "金額不能為空",
						trigger: 'blur',
					}, {
						validator: (rule, value, callback) => {
							if (!Number.isInteger(Number(value)) || value === '' || value <= 0) {
								callback(new Error('金額必須是大於0的整數'));
							} else {
								callback();
							}
						},
						trigger: 'blur'
					}
					],
					postage: [{
						required: true,
						message: "郵費不能為空",
						trigger: 'blur',
					}, {
						validator: (rule, value, callback) => {
							if (!Number.isInteger(Number(value)) || value === '') {
								callback(new Error('郵費不能為空'));
							} else {
								callback();
							}
						},
						trigger: 'blur'
					}
					],
				},
				dateLimits: {
					disabledDate: (time) => false, // 初始不限制
				},
				

		dialogTitleVisible: false,
		fullTitle: '',
		payloading:false,
				pay_type:2,
		rulesRankNum: {
					
					num: [
						{
						required: true,
						message: "機器人數量不能為空",
						trigger: 'blur',
						},
						{
						validator: (rule, value, callback) => {
							if (value <= 0) {
							callback(new Error("機器人數量不能小於或等於 0"));
							} else if (value > this.robotNum) {
							callback(new Error(`機器人數量不能大於 ${this.robotNum}`));
							} else {
							callback();
							}
						},
						trigger: 'blur'
						}
					],
				},
		createRobotModel: false,
		robotNum: 0,
		robotInNum: 0,
		formRobot:{
					num:0,
				},
				user_gift: [],//禮物列表
		dialogVisible: false,
		fullTitle: '',
		selectedRowId: null,  // 保存选中行的ID
		createModel: 0,
		chartsModel: false,
		checkTopicModel: false,
		createQueueModel: false,
		editIndex: -1,
		head_list:[],
		order_list:[],

		ruless: {
					school_id: [
						{
							validator: (rule, value, callback) => {
								if (this.form.is_school === 3 && (!value || value.length === 0)) {
									callback(new Error("參加學校不能為空"));
								} else {
									callback();
								}
							},
							trigger: 'change'
						}
					],
					user_label_ids: [
						{
							validator: (rule, value, callback) => {
								if (this.form.is_school === 4 && (!value || value.length === 0)) {
									callback(new Error("用戶標籤不能為空"));
								} else {
									callback();
								}
							},
							trigger: 'change'
						}
					],
					title: [{
						required: true,
						trigger: 'blur', // 触发方式是失去焦點
						validator: (rule, value, callback) => {
							// 如果值为空，则返回错误
							if (!value) {
							callback(new Error("比賽名稱不能為空"));
							return;
							}

							// 计算中文和英文字符的長度
							const chineseCount = value.replace(/[^\u4e00-\u9fa5]/g, "").length; // 计算中文字符數
							const englishCount = value.replace(/[\u4e00-\u9fa5]/g, "").length; // 计算英文字符數

							// 判断中文字符是否超過限制
							if (chineseCount > 35) {
							callback(new Error("中文長度不能超過35个"));
							return;
							}

							// 判断英文字符是否超過限制
							if (englishCount > 70) {
							callback(new Error("英文長度不能超過70个"));
							return;
							}

							// 如果都没问題，验证通过
							callback();
						}
					}
					],
					content: [{
							required: true,
							message: "比賽簡介不能為空",
							trigger: 'blur',
						},
					],
					time: [{
							required: true,
							message: "請選擇報名時間",
							trigger: 'change',
						},
					],
					com_time: [{
							required: true,
							message: "請選擇比賽日期",
							trigger: 'change',
						},
					],
					result_date: [{
							required: true,
							message: "請選擇比賽公布日期",
							trigger: 'change',
						},
					],
					end_time: [{
							required: true,
							message: "請選擇獎品訂購截止日期",
							trigger: 'change',
						},
					],
					notice_end_time: [{
							required: true,
							message: "請選擇公告展示截止日期",
							trigger: 'change',
						},
					],
					check_rank_time: [{
							required: true,
							message: "請選擇查看成績截止日期",
							trigger: 'change',
						},
					],
					paperList: [{
							required: true,
							message: "請添加比賽試卷",
							trigger: 'blur',
						},
					],
					ranking: [{
							required: true,
							message: "請添加名次獎品",
							trigger: 'blur',
						},
					],
				},
				 updateRankNum: false,
      rules: {
					
       
          num: [
              {
              required: true,
              message: "榜單顯示人數不能為空",
              trigger: 'blur',
              },
              {
              validator: (rule, value, callback) => {
                if (value < 3) {
                callback(new Error("榜單顯示人數不能小於 3"));
                } else {
                callback();
                }
              },
              trigger: 'blur'
              }
            ],
          },
		  previewSrc: '',
		  prizeUserTitle: '',
		  pyaOrderModel: false,
		topForm:{
			title: '',
					answer:[''],
					answer_o:'a',
					difficulty:1,
					icon: "",
					img:"",
					label_id: null,
					label_name: '',
					topic_type: 1,
					option_a: '',
					option_b: '',
					option_c: '',
					option_d: '',
					score: 10,
					status: 0,
					use_time: 0,
					sel_time: 0,
					option_sel:"",
					upload:[],
					max_len:100,
				},
		com_info:[],
		rankList:[],
  
		createPaperModel:false,
		isSubmitting:false,

		createTopicModel:false,
		createRankingModel:false,
		formRanking:{
					level_name:'',
					prize:[],
					sum:1,
					level:4,
					rank_show:0,
					diamond:0,
					money:0,
					gift_id:''
				},
		formTopic:{},
		formQueue:{},
		editTagIndex:-1,
		scoreId: 0,
		pageScore: {
				  current: 1,
				  sizes: [50, 100, 200, 300, 500],
				  size: 200,
				  total: 0
			  },
		//搜索數据
		from: {
		  title: "",
		  com_no: "",
		  ins_name: "",
		  pay_type: -1,
		  status: -1,
		  time: [],
		},
		//搜索數据
		fromTopic: {
		  name: "",//學生名稱
		  user_no:"",
		  school_name: "",//學校名稱
		  email: "",//學生郵件
		},
		auth_val: "Competition",
		preUrl: "data/getComList", //列表地址
		delAllUrl: "data/delCompetitionAll", //批量删除地址
		delUrl: "data/delCompetition", //删除單条地址
		addUrl: "data/addCompublish", //添加/修改地址
				
		editStatusUrl: "data/editStatusCompetition", //修改狀態地址
		colors: ['#99A9BF', '#F7BA2A', '#FF9900'],  // 等同于 { 2: '#99A9BF', 4: { value: '#F7BA2A', excluded: true }, 5: '#FF9900' }
		tableData: [],
		form: { 
			user_label_ids: [], 
			is_school: 0, 
			school_id: [],
			title_vice: "",
			title_vices: "",
			title_vice_img1: "",
			title_vice_img1_logo: "",
			title_vice_img2: "",
			title_vice_img2_logo: "",
			logo: "",
			img: "",
			is_show_time: 1
		},
		groupList: [],//比賽科目列表
		userTopicList: [],//參加科目學生列表
		com_info_user_id: null,
		com_info_user: [],
		input1:'',
				discount_money:0,
		fromUser:{
					user_no:'',
					name:'',
					school_name:'',
					class_id:'',
				},
				selectedPrizeUsers: [] ,// 选中的用戶購買數據
		label_ids: null,
		createTagModel:false,
		formPaper: {
					name: '',
					time: 60,
					timeArr: this.cinstTime(),
					latest_time: '',
					total_score:0,
					count:0,
					topList:[],//題目數組
					grade_id:[]//年級數組
				},

		active: 0, //步骤數
		inputVisible: false,
		payloading: false,
		FenModel: false,
		FenGroupModel: false,
		FenGroupTitle: '',
		tableFenData: [],
		SchoolModel: false,
		SchoolData: [],
		inputValue: "",
		label_list: [],
		tablePrizeData: [],
		dialog_suer_pay_list: [],
		formRank: [],
		selectedUsers: [] ,// 选中的用戶數据
		all_label_list: [],
		subject_list: [],
		school_list: [],
		grade_list: [],
		dialog_list: [],
		rule_list: [],
		check_img_list: [],
		update_com: 0,
		sortProp: "rank", // 當前排序字段
      	sortOrder: "ascending", // 當前排序顺序
	  };
	},
	watch: {
			refreshTrigger(newVal) {
				console.log('刷新触发，當前值:', newVal);
				this.getList();    // 如果有其他需要刷新的方法
				this.layout.getPageNum();
			},
			
		},
		
	created() {
	  this.commonList(["school_list", "topic_subject_label",'user_gift']);
	  this.fetchUserLabels();
	},
	computed: {
		...mapState(['refreshTrigger']), // 监听 Vuex state
	  processedGradeList() {
		// 創建一个新數組，確保不直接修改原始數据
		return this.grade_list.map((grade) => {
		  // 检查 this.form.paperList 中任一 paper 的 grade_id 數組是否包含當前 grade 的 id
		  const isDisabled = this.form.paperList.some((paper) =>
			paper.grade_id.includes(Number(grade.id))
		  );
		  // 返回新的对象，并可能添加 disabled 属性
		  return {
			...grade,
			disabled: isDisabled,
		  };
		});
	  },
	  // 计算选中的人數
	  selectedPrizeCount() {
				return this.selectedPrizeUsers.length;
			},

			// 计算合计金額
			totalPrizeAmount() {
				let sum = 0;
				if (this.selectedPrizeUsers && this.selectedPrizeUsers.length > 0) {
					this.selectedPrizeUsers.forEach(user => {
						sum += Number(user.prizeMoney || 0);
					});
				}
				return sum;
			},
			// 學習排名彈框動態列（名次）
			dynamicColumns() {
				return this.SchoolData.length > 0 && this.SchoolData[0].rank ? this.SchoolData[0].rank : [];
			},
		
	  // 计算选中的人數
	  selectedCount() {
				return this.selectedUsers.length;
			},

			// 计算合计金額
			totalAmount() {
				let sum = 0;
				if (this.selectedUsers && this.selectedUsers.length > 0) {
					this.selectedUsers.forEach(user => {
						sum += Number(user.money || 0);
						sum += Number(user.postage || 0);
					});
				}
				return sum;
			},
			
			// 计算合计支付金額
			totalPayAmount() {
				let sum = 0;
				if (this.selectedUsers && this.selectedUsers.length > 0) {
					this.selectedUsers.forEach(user => {
						sum += Number(user.money || 0);
						sum += Number(user.postage || 0);
						sum -= Number(this.discount_money || 0);
					});
				}
				// 確保合计支付金額不小于零
				return Math.max(sum, 0);
			},
			
			// 優惠金額
			totalDiscount() {
				let sum = 0;
				if (this.selectedUsers && this.selectedUsers.length > 0) {
					this.selectedUsers.forEach(user => {
						sum += Number(this.discount_money || 0);
					});
				}
				// 確保優惠金額不会大于合计金額
				return Math.min(sum, this.totalAmount);
			}
	},
	methods: {
		export_excel() {
			this.$confirm('是否導出當前比賽數據', '提示', {
				confirmButtonText: '確定',
				cancelButtonText: '取消',
				type: 'warning',
			}).then(() => {
				// 用户点击"确定"后的操作
				this.layout.loading = true;

				this.axios.post(
					"/admin/data/export_excel",
					{ com_info_id: this.scoreId },
					{ token: true }
				)
				.then((res) => {
					let all = res.data
					console.log(all);
						if (all.code == 1) {
							this.exportUrl = all.data.list;
							
							// 弹出询问框，用户手动点击后打开
							this.$confirm('導出已經完成，是否打開？', '提示', {
								confirmButtonText: '打開',
								cancelButtonText: '取消',
								type: 'success'
							}).then(() => {
								// 用户点击 "打开" 后跳转（不会被拦截）
								window.open(this.exportUrl, '_blank');

								this.$message({
									message: '導出完成',
									type: 'success'
								}); // 控制是否顯示成功提示
							})

							
							
						}else{
							this.$message.error('操作失敗');
						}
						this.layout.loading = false;
				})
				.catch((err) => {
					this.layout.loading = false;
				});
			}).catch(() => {
				// 用户点击"取消"后关闭 loading（如果有必要）
				this.layout.loading = false;
			});
		},

			 // 處理選擇变化DA
			 handleSelectionChanges(selection) {
				this.selectedUsers = selection;
			},
			// 處理比賽時間范围变化
			handleTimeRangeChange(val) {
				if (val && val.length === 2) {
					const [startTime, endTime] = val;

					// 动态设置 "最遲入場時間" 的日期范围
					this.latestTimePickerOptions = {
					disabledDate(time) {
						const currentDate = time.setHours(0, 0, 0, 0); // 将時間部分归零，仅比较日期
						const startDate = new Date(startTime).setHours(0, 0, 0, 0);
						const endDate = new Date(endTime).setHours(0, 0, 0, 0);

						// 限制日期范围：不在范围内的日期禁用
						return currentDate < startDate || currentDate > endDate;
					},
					};
				} else {
					// 清空最遲入場時間限制
					this.latestTimePickerOptions = {};
				}
			},
			searchEventUser(){
				this.payloading = true;
				this.setStudentList(this.com_info_user)
			},
			setStudentLists(row){
				this.com_info_user = row;
				this.com_info_user_id = row.id;
				this.pay_type = row.pay_type
				this.dialog_suer_pay_list = [];
				this.createUserModel = true;
				this.clearSearchUser();
			},
			setStudentList(row){
				this.com_info_user = row;
				this.com_info_user_id = row.id;
				this.axios.post('/admin/user/getComUserList', {
					com_info_id: row.id,
					name: this.fromUser.name,
					class_id: this.fromUser.class_id,
					user_no: this.fromUser.user_no,
					school_name: this.fromUser.school_name,
					}, {
						token: true,
					}).then(res => {
						let all = res.data
						this.payloading = false;
						if (all.code == 1) {
							let list = all.data.list
							this.dialog_suer_pay_list = list
							this.pay_type = row.pay_type
							this.createUserModel = true;
						}
					}).catch(err => {
						this.$message.warning("暫無合適的學生");
						this.payloading = false;
						return;
						// 失敗
						// this.layout.loading = false;
					})
			},
			// 验证最遲入場時間是否在范围内
			validateLatestTime(val) {
				if (!this.formPaper.timeArr || this.formPaper.timeArr.length !== 2) {
					this.$message.error('請先選擇比賽時間範圍');
					this.formPaper.latest_time = ''; // 清空最遲入場時間
					return;
				}

				const [startTime, endTime] = this.formPaper.timeArr;
				const selectedTime = new Date(val).getTime();
				const start = new Date(startTime).getTime();
				const end = new Date(endTime).getTime();

				if (selectedTime < start || selectedTime > end) {
					this.$message.error('最遲入場時間必須在比賽時間範圍內，請重新選擇');
					this.formPaper.latest_time = ''; // 清空不合法的選擇
				}
			},
			submitSelectionPrize(){
				if (this.selectedUsers.length == 0) {
					this.$message.warning("請先選擇學生");
					return;
				}
				
				this.$set(this.tablePrizeData[this.tablePrizeDataIndex], 'userList', this.selectedUsers);
				this.$set(this.tablePrizeData[this.tablePrizeDataIndex], 'userCount', this.selectedCount);
				this.$set(this.tablePrizeData[this.tablePrizeDataIndex], 'prizeMoney', this.totalAmount);
				this.$refs.prizeTable.toggleRowSelection(this.tablePrizeDataRow, true);
				this.pyaOrderModel = false; // 關閉对话框
			},
			// 提交选中的數据（购物车）
			submitSelectionCart(type) {
				if (type == 2 && this.selectedPrizeUsers.length == 0) {
					this.$message.warning("請先選擇獎品");
					return;
				}
				if (type == 1 && this.selectedUsers.length == 0) {
					this.$message.warning("請先選擇學生");
					return;
				}
				// this.isSubmitting = true;
				const post = {
					discount_code: this.input1,
					
					type: type,
					com_id: this.com_info_user_id,
					...(type === 1 
						? { user: this.selectedUsers } 
						: { price: this.selectedPrizeUsers })
				};
				this.axios.post('/admin/data/userJoinCart', post, {
					token: true,
				}).then(res => {
					const all = res.data;
					console.log(all);
					if(all.code == 1){
						this.$message.success("操作成功");
						// this.isSubmitting = false;
						// this.createUserModel = false; // 關閉对话框
						this.handlePaymentComplete(); // 刷新數据
					}else{
						this.isSubmitting = false;
					}
				}).catch(err => {
					// this.pyaOrderDialog = false;
					this.isSubmitting = false;
					this.$message.error("提交失敗，請稍後再試");
				});
			},
			handlePaymentComplete() {
				this.isSubmitting = false;
				this.createUserModel = false; // 關閉添加學生的对话框
				this.payloading = false;
				this.pyaOrderModel = false; // 關閉添加學生的对话框
				this.FenModel = false; // 關閉添加學生的对话框
				this.layout.getPageNum();
				// this.getsearchEvent(); // 刷新數据
			},
			handleInput(value) {
				if(value == this.com_info.discount_code){
					this.discount_money = this.com_info.discount_money;
				}else{
					this.discount_money = 0;
				}
			},
			
			openPrizeModel(row){
				this.com_info_user_id = row.id;
				this.prizeTitle = '獎品獲得情況 - ' + row.name
				this.layout.loading = true;
				this.axios.post('/admin/data/competitionPrizeList', {
					com_id: row.competition_id,
					com_info_id: row.id,
				}, {
					token: true,
				}).then(res => {
					let all = res.data
					let list = all.data.list
				
					this.tablePrizeData = list
					this.FenModel = true
					this.layout.loading = false;
				}).catch(err=> { 
					// 失敗
					this.layout.loading = false;
				})
			},
			//幫忙訂購買
			openOrderModel(row){
				this.selectedUsers = []
				this.axios.post('/admin/data/getComPrizeUserList', row, {
						token: true,
					}).then(res => {
						let all = res.data
						let list = all.data.list
						this.prizeUserTitle = '添加學生：'+row.name+' - '+row.content
						this.dialog_suer_pay_list = list
						this.priceInfo = row
						 // 默认选中 row.userList 中的用戶
						if (row.userList && row.userList.length > 0) {
							row.userList.forEach(user => {
								const userInTable = this.dialog_suer_pay_list.find(item => item.id === user.id); // 假设 user_no 是唯一標识符
								if (userInTable) {
									this.$nextTick(() => {
										this.$refs.userTable.toggleRowSelection(userInTable, true); // 默认选中该行
									});
								}
							});
							
						}
						this.pyaOrderModel = true;
						this.tablePrizeDataIndex = row.index;
						this.tablePrizeDataRow = row;
						
					}).catch(err => {
						console.log(err)
						this.$message.warning("暫無合適的學生");
						return;
				})
			},
		updateDateLimits(dates) {
				if (dates && dates.length === 2) {
					const endDate = new Date(dates[1]).getTime(); // 報名結束日期
					this.dateLimits = {
						disabledDate: (time) => {
							return time.getTime() < endDate;
						},
					};
				} else {
					this.dateLimits = {
						disabledDate: (time) => false, // 无限制
					};
				}
			},
			clearSearchUser(){
				this.fromUser = {
					name:'',
					school_name:'',
					user_no:'',
					class_id:'',
				}
			},
			submitRankNum(){
          this.$refs.formRank.validate((valid) => {
            if (valid) {
              this.axios.post(
                "/admin/data/updateRankNum",
                this.formRank,
                {
                    token: true,
                }
                )
                .then((res) => {
                  if (res.data.code === 1) {
                    this.groupList.forEach((item, index) => {
                      if (item.id === this.formRank.id) {
                        item.rank_num = this.formRank.num;
                      }
                    });
                  }
                  this.updateRankNum = false; // 關閉模型
                })
                .catch((err) => {
                // 失敗
                this.updateRankNum = false; // 關閉模型
              });
            }
          });
        },
		handlePreview(imgUrl) {
				if(imgUrl.img_type){
					this.previewSrc = imgUrl.icon;
				}else{
					this.previewSrc = imgUrl.img;
				}
				
				this.$nextTick(() => {
				// 触发 el-image 内部的 preview 功能
				this.$refs.previewImage.showViewer = true;
				});
			},
			startEditing(res) {
          // 设置当前行为编辑模式
          this.formRank = {
            id:res.row.id,
            name:res.row.name,
            num:res.row.rank_num,
          }
          this.updateRankNum = true
          
        },
		deleteTagAll(){
				this.formPaper.topList = []
			},
			deleteTag(scope) {
				// 獲取要刪除的題目 ID 或索引
				const index = scope.$index; // 行的索引
				this.formPaper.topList.splice(index, 1); // 刪除對應行
			},
		downloadTemplate() {
				// 文件的 URL (可以是相對路徑或完整URL)
				// const baseUrl = 'https://api.yifangmeng.com';
				const baseUrl = 'https://api.lets-go.fun';
				const filePath = '/excel/題目模版文件.xlsx';
				const fileUrl = `${baseUrl}${filePath}`;
				const link = document.createElement('a');
				link.href = fileUrl;
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link); // 移除鏈接節點
			},
		delPrize(scope){
				// 獲取要刪除的獎品 ID 或索引
				const index = scope.$index; // 行的索引
				this.formRanking.prize.splice(index, 1); // 刪除對應行
			},
			//导入exle
			
			hideFenModel() {
				this.FenModel = false
			},
			// 訂單數導出（下載文件名使用比賽標題）
			openExl(com_id, competitionTitle) {
				this.layout.loading = true;
				this.axios.post('/admin/data/orderInfoExlList', { com_id: com_id }, { token: true }).then(res => {
					const baseUrl = 'https://api.lets-go.fun/';
					const filePath = res.data.data;
					const fileUrl = `${baseUrl}${filePath}`;
					const link = document.createElement('a');
					link.href = fileUrl;
					const safeName = (competitionTitle || '訂單明細').replace(/[/\\:*?"<>|]/g, '_').trim() || '訂單明細';
					link.download = safeName + '.xlsx';
					document.body.appendChild(link);
					link.click();
					document.body.removeChild(link);
					this.layout.loading = false;
				}).catch(err => {
					this.layout.loading = false;
					console.error(err);
				});
			},
			// 分組（組別列表）
			openFenModel(row) {
				this.layout.loading = true;
				this.FenGroupTitle = row.com_no + ' - ' + row.title;
				this.axios.post('/admin/data/competitionGroupList', { com_id: row.id }, { token: true }).then(res => {
					let all = res.data;
					let list = all.data.list || [];
					this.tableFenData = list;
					this.FenGroupModel = true;
					this.layout.loading = false;
				}).catch(err => {
					this.layout.loading = false;
				});
			},
			hideFenGroupModel() {
				this.FenGroupModel = false;
				this.tableFenData = [];
			},
			// 學習排名（學校排名）
			openSchool(row) {
				this.layout.loading = true;
				this.FenGroupTitle = row.com_no + ' - ' + row.title;
				this.axios.post('/admin/data/ComSchoolRank', { id: row.id }, { token: true }).then(res => {
					let all = res.data;
					let list = all.data.list || [];
					list = list.map(item => ({
						...item,
						com_count: item.com_count || 0,
						submit_count: item.submit_count || 0,
						paper_count: item.paper_count || 0
					}));
					this.SchoolModel = true;
					this.SchoolData = list;
					this.layout.loading = false;
				}).catch(err => {
					this.SchoolModel = true;
					this.SchoolData = [];
					this.layout.loading = false;
				});
			},
			hideSchoolModel() {
				this.SchoolModel = false;
				this.SchoolData = [];
			},
			rowClassName({row, rowIndex}) {
		      //把每一行的索引放进row
		       row.index = rowIndex;
		    },
			handleSelectionPrizeChanges(selection){
				this.selectedPrizeUsers = selection;
			},
			//导入exle
			beforeUpload(file) {
				const reader = new FileReader();
				reader.onload = (e) => {
					const data = new Uint8Array(e.target.result);
					const workbook = XLSX.read(data, { type: 'array'});
					
					// 假设你的數据在第一个 sheet 中
					const firstSheet = workbook.Sheets[workbook.SheetNames[0]];
					
					// 解析 Excel 數据，header: 1 会返回二维數組形式的數据
					// const jsonData = XLSX.utils.sheet_to_json(firstSheet, { header: 2 });
					const jsonData = XLSX.utils.sheet_to_json(firstSheet, {
						header: 2,
						raw: false // ✅ 保留原样字符串（关键）
					});
					// 去除第一行（表头）
					// jsonData.shift();

					// 将解析後的數据處理成需要的格式
					this.handleExcelData(jsonData);
				};
				reader.readAsArrayBuffer(file);

				// 阻止默認的上傳行为
				return false;
			},
			handleExcelData(jsonData) {
				// 首先检查所有數据的科目類型是否一致
				const isSubjectValid = jsonData.every(row => Number(row.subject) === this.form.subject_id);
				if (!isSubjectValid) {
					// 如果科目類型不一致，提示错误信息
					this.$message.error('科目類型不正確'); // 使用消息提示
					return; // 取消上傳，结束方法
				}

				  // 檢查是否有重複的題目
				const duplicateTitle = jsonData.find(row => 
					this.formPaper.topList.some(item => item.title === row.title)
				);

				if (duplicateTitle) {
					this.$message.warning(`題目 "${duplicateTitle.title}" 已經存在，請確認後再上傳`);
					return; // 停止處理，退出方法
				}

				// 如果科目類型正確，继续處理數据
				jsonData.forEach(row => {
					const label = this.label_list.find(label => label.label_id === Number(row.label_id)); // 根据 label_id 查找標籤
					const labelName = label ? label.name : ''; // 获取標籤名稱，如果找不到则为空
					const labelId = label ? label.id : 1; // 获取標籤名稱，如果找不到则为空
					const topForm = {
						title: row.title || '',            // 从 Excel 的數據中讀取標題
						answer: row.topic_type == 2 
					? (typeof row.answer === 'string' 
						? (row.answer.includes(',') ? row.answer.split(',') : [row.answer]) 
						: row.answer) 
					: [''],
						answer_o: row.answer_o || 'a',     // 选项答案
						difficulty: row.difficulty || 1,    // 難度
						img: row.img || '',                // 圖片
						label_id: labelId,      // 標籤 ID
						label_name: labelName,              // 从 label_list 获取標籤名稱
						topic_type: row.topic_type || 1,    // 題目類型
						option_a: row.hasOwnProperty('option_a') ? row.option_a : '', // 选项 A
						option_b: row.hasOwnProperty('option_b') ? row.option_b : '', // 选项 B
						option_c: row.hasOwnProperty('option_c') ? row.option_c : '', // 选项 C
						option_d: row.hasOwnProperty('option_d') ? row.option_d : '', // 选项 D
						score: row.score || 10,            // 分數
						status: row.status || 0,           // 狀態
						use_time: row.use_time || 0,       // 使用時間
						sel_time: row.sel_time || 0,       // 選擇時間
						option_sel: row.option_sel || '',   // 選擇的选项
						upload: row.upload || [],           // 上傳文件信息
						subject: row.subject || 1,          // 科目
						max_len: row.max_len || 100         // 最大長度
					};


					// 将數据 push 到 formPaper.topList 中
					this.formPaper.topList.push(topForm);

					// 计算數量和分數總和
					this.formPaper.total_score = this.formPaper.topList.reduce((sum, item) => sum + Number(item.score), 0);
					this.formPaper.count = this.formPaper.topList.length;
				});
			},

			handleAvatarSuccessLogo(res, file) {
				this.form.logo = URL.createObjectURL(file.raw);
				let en_data = commondecrypt(res.encryption)
				res.encryption = JSON.parse(en_data)
				if(res.encryption.code==1){
					this.form.img = res.encryption.data.list.url
				}
			},



		 // 顯示完整標題内容
		 showFullTitle(title) {
				this.fullTitle = title;
				this.dialogTitleVisible = true;
			},
			  // 打开模态框
			  checkTopic(e) {
		  this.layout.loading = true;
				  this.axios.post('/admin/data/getTopicInfoCom', {
					  id: e,
				  }, {
					  token: true,
				  }).then(res => {
					  let all = res.data.data
			this.dialog_list = all.list;
  
			// 打开dialog
			this.checkTopicModel = true
					  this.layout.loading = false;
				  }).catch(err => {
					  // 失敗
					  this.layout.loading = false;
				  })
			  },
  
	   //修改排序
	  queue(){
		this.createQueueModel = true;
	  },
	  handleLevelChange(row) {
		  row.rank_type = 1
		  this.layout.loading = true;
		  // 在这里可以执行其他逻辑，例如更新數据或触发其他操作
		  this.axios.post(
			"/admin/data/updateRank",
			row,
			{
			  token: true,
			}
		  )
		  .then((res) => {
			// 修改成功则不操作
			this.addRanking(this.scoreId)
			this.layout.loading = false;
		  })
		  .catch((err) => {
			// 修改失敗时恢复下拉框选项值
			this.layout.loading = false; // 停止加載狀態
		  });
		},
		submitRobot(){
				this.$refs.formEdit.validate(res => {
					if (res) {
						this.layout.loading = true;
						this.axios.post('/admin/data/setRobot', this.formRobot, {
							token: true,
						}).then(resg => {
							// 打开dialog
							// this.getComInfo()
							this.createRobotModel = false;
							this.layout.loading = false;
						}).catch(err => {
							// 失敗
							this.layout.loading = false;
						})
					}
				})
				
			},
	  submitQueue() {
		this.layout.loading = true;
		this.axios.post(
			  "/admin/data/updateRank",
			  {rank_type:2,data:this.formQueue,com_info_id:this.scoreId},
			  {
				  token: true,
			  }
			  )
			  .then((res) => {
				this.addRanking(this.scoreId)
				  this.createQueueModel = false;
				   this.layout.loading = false;
			  })
			  .catch((err) => {
			  // 失敗
			  this.layout.loading = false;
			  this.createQueueModel = false; // 關閉模型
		});
	  
	  },
	  cinstTime(){
				// 获取當前日期
				const currentDate = new Date();
				const year = currentDate.getFullYear();
				const month = String(currentDate.getMonth() + 1).padStart(2, '0'); // 月份从0开始，所以+1
				const day = String(currentDate.getDate()).padStart(2, '0');

				// 生成完整的日期字符串格式，如 '2024-11-03'
				const formattedDate = `${year}-${month}-${day}`;

				// 使用默認時間并将日期和時間拼接起来
				return ['08:00:00', '09:00:00'].map(time => `${formattedDate} ${time}`);
			},
	  setRobot(id){
				this.formRobot ={
					num:0,
					id:id,
				},
				// this.layout.loading = true;
				this.axios.post('/admin/data/getRobotNum', this.formRobot, {
					token: true,
				}).then(res => {
					// 打开dialog
					this.robotNum = res.data.data.robotNum;
					this.robotInNum = res.data.data.robotInNum;
					this.createRobotModel = true;
					
					this.layout.loading = false;
				}).catch(err => {
					// 失敗
					this.layout.loading = false;
				})
				// this.layout.loading = true;
				
			},
		   // 顯示完整題目内容
			  showFullTitle(title) {
				  this.fullTitle = title;
				  this.dialogVisible = true;
			  },
			  //添加修改名次
			addRankings(e = false){
				
					// 修改
					this.formRanking = {
						is_default: e.row.is_default || 0,
						id: e.row.id,
						level_name: e.row.level_name,
						prize: e.row.prize,
						level:e.row.level,
						rank_show:e.row.rank_show,
						sum: e.row.sum,
						diamond: e.row.diamond,
						money: e.row.money,
						gift_id: e.row.gift_id,
					}
			
			
				// 打开dialog
				this.createRankingModel = true
			},
	  checkCharts(com_info_id) {
		this.layout.loading = true;
		  this.axios.post(
			  "/admin/data/scoreCheckList",
			  { com_info_id: com_info_id },
			  { token: true }
		  )
		  .then((res) => {
			  this.order_list = res.data.data.list;
			  this.chartsModel = true;  // 设置 chartsModel 为 true，触发弹窗顯示
			  this.layout.loading = false;
		  })
		  .catch((err) => {
			  // 處理错误
			  this.layout.loading = false;
			  this.createQueueModel = false;
		  });
	  },
	  initChart() {
		  this.$nextTick(() => {
			  this.drawLine();
		  });
	  },
	  async handleSortChange({ prop, order }) {
		this.sortProp = prop; // 更新排序字段
		this.sortOrder = order; // 更新排序顺序
		this.getUserTopicList()
	},
	  drawLine() {
		  if (!this.$refs.myChart) {
			  console.error("myChart reference is undefined");
			  return;
		  }
		  
		  // 初始化 ECharts 实例
		  let myChart = echarts.init(this.$refs.myChart,null,{ locale: 'EN' });
  
		  // 配置图表參數
			myChart.setOption({
				tooltip: {
					trigger: 'axis'
				},
				legend: {
					data: ['人數']
				},
				grid: {
					left: '3%',
					right: '4%',
					bottom: '3%',
					containLabel: true
				},
				toolbox: {
					feature: {
						magicType: { show: true, type: ['bar','line'] },  // 允许用戶切换图表類型
						restore: { show: true },
						saveAsImage: {}
					}
				},
				xAxis: {
					type: 'category',
					// boundaryGap: false,
					data: this.order_list?.score || []  // 如果 score 數据缺失，使用空數組
				},
				yAxis: {
					type: 'value'
				},
				series: [
					{
						name: '人數',
						type: 'bar',  // 修改为柱状图
						
						color: '#ffda4a',
						data: this.order_list?.count || []  // 如果 count 數据缺失，使用空數組
					}
				]
			});
	  },
	   // 清空篩選條件
	   clearSearchTopic() {
		this.fromTopic = {
		  name: "",//學生名稱
		  user_no:"",
		  school_name: "",//學校名稱
		  email: "",//學生郵件
		};
  
		//this.$refs.buttonSearch.closeSuperSearch();
		this.search = "";
		this.getList();
	  },
	  searchEventTopic(e = false) {
			  // 簡單搜索
			  if (typeof e === 'string') {
				  this.search = e;
				  this.getUserTopicList()
				  return
			  }
			  this.search = this.fromTopic
			  this.getUserTopicList()
		  },
	  //修改成績弹框
	  updateTopic(data){
		  this.formTopic = {
			  score : data.score,
			  use_time : data.use_time,
			  name : data.name,
			  school_name : data.school_name,
			  email : data.email,
			  rank : data.rank,
			  com_info_id : data.com_info_id,
			  id : data.is_none,
			  user_com_id : data.id,
		  }
		  this.createTopicModel = true;
	  },
	 
	  //修改成績并重新排名
	  submitTopic(){
		  this.axios
			  .post(
			  "/admin/data/updateTopic",
			  this.formTopic,
			  {
				  token: true,
			  }
			  )
			  .then((res) => {
				  this.addRanking(this.scoreId)
				  this.createTopicModel = false;
			  })
			  .catch((err) => {
			  // 失敗
			  this.layout.loading = false;
		  });
		 
		  this.resetTagForm();
	  },
	  	openModels(id,status) {
			if(status === 2 || status === 3){
				this.update_com = 1;
			}

			this.axios
			  .post(
			  "/admin/data/comInfoData",
			  {id:id},
			  {
				  token: true,
			  }
			  )
			  .then((res) => {
				
					this.form = res.data.data.list.list
					
					this.form.school_id = this.form.school_id ? this.form.school_id.map(id => Number(id)) : []
					
					// 解析後端返回的 label_id 作為回填
					this.$set(this.form, 'user_label_ids', this.form.label_id ? this.form.label_id.split(',').filter(Boolean).map(v => Number(v)) : [])

					// 设置图片预览，确保字段存在
					this.$set(this.form, 'title_vice_img1_logo', this.form.title_vice_img1 || '')
					this.$set(this.form, 'title_vice_img2_logo', this.form.title_vice_img2 || '')

					this.editIndex = this.form.id
					this.createModel = 2;
			  })
			  .catch((err) => {
			  // 失敗
			//   this.layout.loading = false;
		  });
		 

			// this.createModel = 2;
	  	},
	  // 打开模态框
	  openModel(e) {
		this.layout.loading = true;
		this.axios
		  .post(
			"/admin/data/getGroupList",
			{
			  id: e,
			},
			{
			  token: true,
			}
		  )
		  .then((res) => {
			
			this.groupList = res.data.data.list.list,
			this.com_info = res.data.data.list.com_info
			console.log(this.com_info)
			this.editIndex = e;
			this.pageScore.total = 0
			this.userTopicList = []
			this.formQueue = []
			// 打开dialog
			this.createModel = 1;
			this.layout.loading = false;
		  })
		  .catch((err) => {
			// 失敗
			this.layout.loading = false;
		  });
	  },
	  tableRowClassName({ row }) {
		// 判断行的 ID 是否与选中的 ID 相等，返回不同的類名
		return row.id === this.selectedRowId ? 'selected-row' : '';
	  },
	  addRanking(e){
		  if(e){
			  this.scoreId = e;
			  this.selectedRowId = e;
			  this.pageScore.current = 1;
			  this.search = "";
			  this.fromTopic = {
				name: "",//學生名稱
				user_no:"",
				school_name: "",//學校名稱
				email: "",//學生郵件
			};
		
		  }
		  this.layout.loading = true;
		  this.axios
			  .post(
			  "/admin/data/getUserTopicList",
			  {
				id: this.scoreId,
				page: this.pageScore.current,
				limit: this.pageScore.size,
				search: this.search,
				sortProp: this.sortProp,
				sortOrder: this.sortOrder,
			  },
			  {
				  token: true,
			  }
			  )
			  .then((res) => {
				  let all = res.data.data.list
				  this.pageScore.total = all.total
				  this.userTopicList = all.list
				  this.formQueue = all.rank
				  this.layout.loading = false;
			  })
			  .catch((err) => {
			  // 失敗
			  this.layout.loading = false;
		  });
	  },
	  
			//添加修改名次
			addRankingUpdate(e = false){
				if (!e) {
					// 初始化表單
					this.editRankingIndex = -1
				} else {
					// 修改
					this.formRanking = {
						is_default: e.row.is_default || 0,
						id: e.row.id,
						level_name: e.row.level_name,
						prize: e.row.prize,
						level:e.row.level,
						rank_show:e.row.rank_show,
						sum: e.row.sum,
						diamond: e.row.diamond,
						money: e.row.money,
						gift_id: e.row.gift_id,
					}
					this.editRankingIndex = e.$index
				}
			
				// 打开dialog
				this.createRankingModel = true
			},
	  getUserTopicList(){
		  this.layout.loading = true;
		  this.axios
			  .post(
			  "/admin/data/getUserTopicList",
			  {
				id: this.scoreId,
				search: this.search,
				sortProp: this.sortProp,
				sortOrder: this.sortOrder,
			  },
			  {
				token: true,
			  }
			  )
			  .then((res) => {
				  let all = res.data.data.list
				  this.pageScore.total = all.total
				  this.userTopicList = all.list
				  this.formQueue = all.rank
				  this.layout.loading = false;
			  })
			  .catch((err) => {
			  // 失敗
			  this.$message.error(err);
			  this.layout.loading = false;
		  });
	  },
	  handleScoreSizeChange(val) {
			  this.pageScore.size = val
			  this.addRanking()
	  },
	  handleScoreCurrentChange(val) {
		  this.pageScore.current = val
		  this.addRanking()
	  },
	  //提交成績
	submit() {
		this.$refs.form.validate(res => {
					if (res) {
						this.submitLoading = true;
						this.form.id = this.editIndex
						this.addOrEdit(this.form)
						// 關閉模态框
						// this.resetForm()
					}
				})
	  },
  
  
  
  
	  // 自定义時間验证规则
	  validateTime(rule, value, callback) {
		if (this.formPaper.timeArr.length === 2) {
		  const startTime = this.convertTimeToMinutes(this.formPaper.timeArr[0]);
		  const endTime = this.convertTimeToMinutes(this.formPaper.timeArr[1]);
		  const selectedTime = parseInt(value);
  
		  if (isNaN(selectedTime)) {
			callback(new Error("請輸入有效的做題时長"));
		  } else if (selectedTime > endTime - startTime) {
			callback(new Error("做題时長不能超過比賽時間范围"));
		  } else {
			callback();
		  }
		} else {
		  callback(new Error("請選擇比賽時間范围"));
		}
	  },
	  // 辅助方法：将時間转为分钟數
	  convertTimeToMinutes(time) {
		const [hours, minutes, seconds] = time.split(":").map(Number);
		return hours * 60 + minutes + seconds / 60;
	  },
	  changeType() {
		// 清空當前的 label_list
		this.label_list = [];
  
		// 遍历每个 grade_id 来构建键，并合并结果
		this.formPaper.grade_id.forEach((gradeId) => {
		  let key = `${this.form.subject_id}-${gradeId}`;
		  if (this.all_label_list[key]) {
			this.label_list = [...this.label_list, ...this.all_label_list[key]];
		  }
		});
  
		// 移除可能的重复项，假设每个標籤有唯一的 id
		this.label_list = this.label_list.filter(
		  (label, index, self) =>
			index === self.findIndex((t) => t.id === label.id)
		);
  
		if (this.label_list.length > 0) {
		  // 如果 label_list 不为空，则设置默認选中项为第一个元素的 ID
		  this.label_ids = this.label_list[0].id;
		} else {
		  // 如果 label_list 为空，可以设置 label_id 为 null 或进行其他逻辑處理
		  this.label_ids = null;
		}
	  },
	  next() {
		if (this.active++ > 2) this.active = 0;
	  },
	  createModelbut() {
		this.createModel = 0;
		this.active = 0;
	  },
	  createPaperModelbut() {
		this.createPaperModel = false;
	  },
	  addTag(e = false) {
		// 增加
		if (!e) {
		  if (!this.formPaper.grade_id || this.formPaper.grade_id.length === 0) {
			this.$message.error("請選擇先選擇年級!");
			return; // 提前返回，不执行後面的添加或修改逻辑
		  }
		  this.topForm.label_id = this.label_ids;
		  this.$set(this.topForm, 'answer', ['']);
			// 初始化表單
			(this.editTagIndex = -1);
		} else {
		  // 修改
		  let answerData = [''];
		  
		  if (e.row.topic_type == 2) {
		    if (typeof e.row.answer === 'string' && e.row.answer) {
		      answerData = e.row.answer.split(",");
		    } else if (Array.isArray(e.row.answer) && e.row.answer.length > 0) {
		      answerData = e.row.answer;
		    }
		  }
		  console.log(answerData)
		  // 先重置 topForm
		//   this.resetTagForm();
		  
		  // 然后逐个设置属性，确保响应式更新
		  this.topForm.title = e.row.title;
		//   this.$set(this.topForm, 'answer', answerData);
		  this.topForm.answer_o = e.row.answer_o || 'a';
		  this.topForm.difficulty = e.row.difficulty || 1;
		  this.topForm.icon = e.row.img;
		  this.topForm.img = e.row.img;
		  this.topForm.label_id = e.row.label_id;
		  this.topForm.label_name = e.row.label_name;
		  this.topForm.topic_type = e.row.topic_type;
		  this.topForm.option_a = e.row.option_a;
		  this.topForm.option_b = e.row.option_b;
		  this.topForm.option_c = e.row.option_c;
		  this.topForm.option_d = e.row.option_d;
		  this.topForm.selectedLabel = e.row.selectedLabel;
		  this.topForm.score = e.row.score;

		  // 最后赋值 answer，覆盖 watch 的影响
		this.topForm.answer = answerData;

		  this.editTagIndex = e.$index;
		  console.log(this.topForm.answer)
		}
		
		this.createTagModel = true;
	  },
  
	  handleTagClose(tag) {
		this.topicTags.splice(this.topicTags.indexOf(tag), 1);
	  },
  
	  //添加題目
	  submitTag() {
		this.$refs.topForm.validate((valid) => {
		  if (valid) {
			this.handleLabelChange(this.topForm.label_id);
			this.topForm.img_type = 1;
			
			if (this.topForm.topic_type == 2) {
			  // 过滤空答案
			  this.topForm.answer = this.topForm.answer.filter(answer => answer && answer.trim() !== '');
			  // 保存时转成字符串
			  this.topForm.answer = this.topForm.answer.join(',');
			}
			
			if (this.editTagIndex === -1) {
			  // 添加新題目
			  this.formPaper.topList.push({...this.topForm});
			} else {
			  // 修改现有題目
			  this.$set(this.formPaper.topList, this.editTagIndex, {
				...this.topForm,
			  });
			}
  
			// 计算數量和分數總和
			this.formPaper.total_score = this.formPaper.topList.reduce(
			  (sum, item) => sum + Number(item.score),
			  0
			);
  
			this.formPaper.count = this.formPaper.topList.length;
			// 重置表單和關閉模态框
			this.resetTagForm();
		  }
		});
	  },
	  resetTagForm() {
		this.topForm = {
			title: '',
					answer:[''],
					answer_o:'a',
					difficulty:1,
					icon: "",
					img:"",
					label_id: this.label_ids,
					label_name: '',
					topic_type: 1,
					option_a: '',
					option_b: '',
					option_c: '',
					option_d: '',
					score: 10,
					status: 0,
					use_time: 0,
					sel_time: 0,
					option_sel:"",
					upload:[],
					max_len:100,
		};
		this.createTagModel = false;
		this.editTagIndex = -1; // 重置 editTagIndex
	  },
  
	  //添加修改獎品
	  addPrize(e = false) {
		if (!e) {
		  // 初始化表單
		  this.editPrizeIndex = -1;
		} else {
		  // 修改
		  this.formPrize = {
			name: e.row.name,
			money: e.row.money,
			content: e.row.content,
		  };
		  this.editPrizeIndex = e.$index;
		}
		// 打开dialog
		this.createPrizeModel = true;
	  },
	  submitPrize() {
		this.$refs.formPrize.validate((valid) => {
		  if (valid) {
			if (this.editPrizeIndex === -1) {
			  // 添加新題目
			  this.formRanking.prize.push(this.formPrize);
			} else {
			  // 修改现有題目
			  this.$set(this.formRanking.prize, this.editPrizeIndex, {
				...this.formPrize,
			  });
			}
  
			// 重置表單和關閉模态框
			this.resetPrizeForm();
		  }
		});
	  },
	  resetPrizeForm() {
		this.formPrize = {
		  name: "",
		  money: 0,
		  content: "",
		};
  
		this.createPrizeModel = false;
		this.editPrizeIndex = -1; // 重置 editTagIndex
	  },
  
	
	  submitRanking() {
		this.$refs.formRanking.validate((valid) => {
		  if (valid) {
			if (this.editRankingIndex === -1) {
			  // 添加新題目
			  this.form.ranking.push(this.formRanking);
			} else {
			  // 修改现有題目
			  this.$set(this.form.ranking, this.editRankingIndex, {
				...this.formRanking,
			  });
			}
  
			// 重置表單和關閉模态框
			this.resetRankingForm();
		  }
		});
	  },
	  resetRankingForm() {
		this.formRanking = {
		  level_name: "",
		  prize: [],
		  sum: 1,
		};
  
		this.createRankingModel = false;
		this.editRankingIndex = -1; // 重置 editTagIndex
	  },
  
	  //添加試卷
	  submitPaper() {
		this.$refs.formPaper.validate((valid) => {
		  if (valid) {
			if (this.editPaperIndex === -1) {
			  // 添加新題目
			  this.form.paperList.push(this.formPaper);
			} else {
			  // 修改现有題目
			  this.$set(this.form.paperList, this.editPaperIndex, {
				...this.formPaper,
			  });
			}
  
			// 重置表單和關閉模态框
			this.resetPaperForm();
		  }
		});
	  },
  
	  resetPaperForm() {
		this.formPaper = {
		  name: "",
		  timeArr: [new Date(2016, 9, 10, 8, 40), new Date(2016, 9, 10, 9, 40)],
		  time: 60,
		  total_score: 0,
		  count: 0,
		  topList: [], //題目數組
		  grade_id: [], //年級數組
		};
  
		this.createPaperModel = false;
		this.editPaperIndex = -1; // 重置 editTagIndex
	  },
	  addDomain(e = false) {
		if (!e) {
		  // 初始化表單
		  this.editPaperIndex = -1;
		} else {
		  // 修改
		  this.formPaper = {
						id: e.row.id,
						name: e.row.name,
						time: e.row.time,
						timeArr: e.row.timeArr,
						latest_time:e.row.latest_time,
						total_score: e.row.total_score,
						count:e.row.count,
						topList:e.row.topList,
						grade_id:e.row.grade_id.map(id => Number(id)),
					}
					this.editPaperIndex = e.$index
		}
		// 打开dialog
		this.createPaperModel = true;
	  },
  
	  handleLabelChange(value) {
		if (this.label_list.length > 0) {
		  const selectedItem = this.label_list.find((item) => item.id === value);
		  this.topForm.label_name = selectedItem.name; // 获取和存储 name
		}
	  },
  
	  resetForm() {
		this.form = {
		  subject_id: null,
		  title: "",
		  content: "",
		  logo: "",
		  subject_id: this.form.subject_id,
		  school_id: [],
		  pay_type: 1,
		  is_school: 0,
		  money: 0,
		  time: [],
		  com_time: null,
		  paperList: [], //試卷數組
		  ranking: [], //試卷數組
		  title_vice: "",
		  title_vices: "",
		  title_vice_img1: "",
		  title_vice_img1_logo: "",
		  title_vice_img2: "",
		  title_vice_img2_logo: "",
		  is_show_time: 1
		};
  
		this.createModel = 0;
		this.getList();
		this.editIndex = -1; // 重置 editTagIndex
	  },
  
	  //公共列表
	  commonList(type) {
		this.layout.loading = true;
		this.axios
		  .post(
			"/admin/user/commonList",
			{
			  type: type,
			},
			{
			  token: true,
			}
		  )
		  .then((res) => {
			let all = res.data;
			let list = all.data.list;
			this.school_list = list.school;
			this.grade_list = list.grade;
			this.subject_list = list.subject;
			this.all_label_list = list.label;
			this.user_gift = list.user_gift
			if (this.subject_list.length > 0) {
			  // 设置默認选中项为subject_list中的第一个元素
			  this.form.subject_id = this.subject_list[0].id;
			  this.label_list = list.label[this.subject_list[0].id];
			  if (this.label_list.length > 0) {
				// 设置默認选中项为subject_list中的第一个元素
				this.label_ids = this.label_list[0].id;
			  }
			}
			this.layout.loading = false;
		  })
		  .catch((err) => {
			// 失敗
			this.layout.loading = false;
		  });
	  },
	  handleAvatarSuccessLogo(res, file) {
				this.form.logo = URL.createObjectURL(file.raw);
				let en_data = commondecrypt(res.encryption)
				res.encryption = JSON.parse(en_data)
				if(res.encryption.code==1){
					this.form.img = res.encryption.data.list.url
				}
			},
	  handleAvatarSuccessTitleViceImg1(res, file) {
				this.form.title_vice_img1_logo = URL.createObjectURL(file.raw);
				let en_data = commondecrypt(res.encryption)
				res.encryption = JSON.parse(en_data)
				if(res.encryption.code==1){
					this.form.title_vice_img1 = res.encryption.data.list.url
				}
			},
	  handleAvatarSuccessTitleViceImg2(res, file) {
				this.form.title_vice_img2_logo = URL.createObjectURL(file.raw);
				let en_data = commondecrypt(res.encryption)
				res.encryption = JSON.parse(en_data)
				if(res.encryption.code==1){
					this.form.title_vice_img2 = res.encryption.data.list.url
				}
			},
	  handleAvatarSuccess(res, file) {
		this.topForm.icon = URL.createObjectURL(file.raw);
		let en_data = commondecrypt(res.encryption);
		res.encryption = JSON.parse(en_data);
		if (res.encryption.code == 1) {
		  this.topForm.img = res.encryption.data.list.url;
		}
	  },
	  beforeAvatarUpload(file) {
		const isJPG =
		  file.type === "image/jpeg" ||
		  file.type === "image/png" ||
		  file.type === "image/gif";
		const isLt2M = file.size / 1024 / 1024 < 2;
  
		if (!isJPG) {
		  this.$message.error("文件格式错误!");
		}
		if (!isLt2M) {
		  this.$message.error("上傳图片大小不能超過 2MB!");
		}
		return isJPG && isLt2M;
	  },
	  //前往修改页面
	  editItem(obj) {
		this.$router.push({
		  name: "set_manager_rule",
		  query: {
			item: obj,
		  },
		});
	  },
	  handleClose(done) {
		this.active = 0;
		done();
	  },
	  getListResult(e) {
		this.tableData = e.list;
		this.check_img_list = e.list.map((item) => {
		  return item.head;
		});
	  },
	  // 清空篩選條件
	  clearSearch() {
		this.from = {
		  title: "",
		  com_no: "",
		  ins_name: "",
		  pay_type: -1,
		  status: -1,
		  apply_status: -1,
		  start_status: -1,
		  time: [],
		};
  
		//this.$refs.buttonSearch.closeSuperSearch();
		this.search = "";
		this.getList();
	  },
	  // 選擇图片
	  chooseImage() {
		this.app.chooseImage((res) => {
		  this.$set(this.form, "headUrl", res[0].url);
		  this.form["headId"] = res[0].id;
		  this.$set(this.form, "headId", res[0].id);
		}, 1);
	  },
	  addAnswer() {
		this.topForm.answer.push('');
	  },
	  removeAnswer(index) {
		this.topForm.answer.splice(index, 1);
	  },
	  fetchUserLabels(){
			this.axios.post('/admin/data/userLabelList', { page:1, limit: 9999 }, { token: true }).then(res => {
				const all = res.data;
				this.user_label_options = (all.data && all.data.list && all.data.list.list) ? all.data.list.list : [];
			}).catch(()=>{});
		},
	},
  };
  </script>
  
  <style>
  .el-tag + .el-tag {
	margin-left: 10px;
  }
  .button-new-tag {
	margin-left: 10px;
	height: 32px;
	line-height: 30px;
	padding-top: 0;
	padding-bottom: 0;
  }
  .input-new-tag {
	width: 90px;
	margin-left: 10px;
	vertical-align: bottom;
  }
  .selected-row {
	background-color: #f0f9ff !important; /* 选中行的背景颜色 */
  }
  
.custom-box {
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  padding: 10px;
  display: inline-block;

 
}
.custom-box .el-radio{
	margin-bottom: 0px;
}
  </style>
  